(() => {
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {style:'currency', currency:'INR', maximumFractionDigits:2}).format((cents || 0) / 100);
  const moneyCompact = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {style:'currency', currency:'INR', maximumFractionDigits:0}).format((cents || 0) / 100);
  const preorderPendingCents = (item) => {
    const value = String(item?.properties?._preorder_pending_price || '').replace(/,/g, '').trim();
    const amount = Number(value);
    return Number.isFinite(amount) ? Math.round(amount * 100) : 0;
  };
  const lock = (on) => document.documentElement.classList.toggle('overflow-hidden', on);

  function toggleLayer(layer, open) {
    if (!layer) return;
    layer.classList.toggle('is-open', open);
    layer.setAttribute('aria-hidden', String(!open));
    lock(open);
  }

  const header = $('[data-header]');
  let lastHeaderScrollY = Math.max(window.scrollY || document.documentElement.scrollTop || 0, 0);
  let headerTicking = false;
  const HEADER_TOP_TOLERANCE = 10;
  const HEADER_DIRECTION_THRESHOLD = 3;

  const headerLayerIsOpen = () => Boolean(document.querySelector(
    '.mobile-menu.is-open, .search-overlay.is-open, .drawer.is-open, .wishlist-modal.is-open'
  ));

  const setHeaderVisible = (visible) => {
    if (!header) return;
    header.classList.toggle('mobile-header-visible', visible);
    header.classList.toggle('mobile-header-hidden', !visible);
  };

  const getPageScrollY = () => Math.max(
    window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0,
    0
  );

  function updateHeaderDirection() {
    headerTicking = false;
    if (!header) return;

    const currentY = getPageScrollY();

    // Always keep navigation available at the very top or while a site layer
    // (menu, search, cart, wishlist, request form) is open.
    if (currentY <= HEADER_TOP_TOLERANCE || headerLayerIsOpen()) {
      setHeaderVisible(true);
      lastHeaderScrollY = currentY;
      return;
    }

    const delta = currentY - lastHeaderScrollY;

    // Same behavior on desktop, tablet and mobile:
    // page scroll UP -> show header; page scroll DOWN -> hide header.
    if (delta <= -HEADER_DIRECTION_THRESHOLD) {
      setHeaderVisible(true);
      lastHeaderScrollY = currentY;
    } else if (delta >= HEADER_DIRECTION_THRESHOLD) {
      setHeaderVisible(false);
      lastHeaderScrollY = currentY;
    }
  }

  if (header) setHeaderVisible(true);

  window.addEventListener('scroll', () => {
    if (headerTicking) return;
    headerTicking = true;
    requestAnimationFrame(updateHeaderDirection);
  }, {passive:true});

  // Desktop mouse wheels / trackpads can report direction before the browser
  // paints its scroll position. React immediately so the header feels instant.
  window.addEventListener('wheel', event => {
    if (!header || headerLayerIsOpen() || getPageScrollY() <= HEADER_TOP_TOLERANCE) return;
    if (event.deltaY < -HEADER_DIRECTION_THRESHOLD) setHeaderVisible(true);
    if (event.deltaY > HEADER_DIRECTION_THRESHOLD) setHeaderVisible(false);
  }, {passive:true});

  const menu = $('[data-mobile-menu]');
  const menuButtons = $$('[data-mobile-menu-open]');
  const setMobileMenu = open => {
    toggleLayer(menu, open);
    menuButtons.forEach(button => {
      button.classList.toggle('is-active', open);
      button.setAttribute('aria-expanded', String(open));
    });
  };
  menuButtons.forEach(b => b.addEventListener('click', () => setMobileMenu(true)));
  $$('[data-mobile-menu-close]').forEach(b => b.addEventListener('click', () => setMobileMenu(false)));
  $$('.mobile-nav a', menu).forEach(link => link.addEventListener('click', () => setMobileMenu(false)));

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && menu?.classList.contains('is-open')) setMobileMenu(false);
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth > 900 && menu?.classList.contains('is-open')) setMobileMenu(false);
    lastHeaderScrollY = Math.max(window.scrollY || 0, 0);
    if (headerLayerIsOpen() || lastHeaderScrollY <= 8) setHeaderVisible(true);
  });

  // Short exit motion for ordinary internal navigation.
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = new URL(link.href, location.href);
    if (target.origin !== location.origin || link.target === '_blank' || target.hash === '#wishlist' || target.hash === '#request-model') return;
    document.documentElement.classList.add('page-is-leaving');
  });

  const search = $('[data-search-overlay]');
  $$('[data-search-open]').forEach(b => b.addEventListener('click', () => { toggleLayer(search, true); setTimeout(() => $('[data-predictive-input]', search)?.focus(), 80); }));
  $$('[data-search-close]').forEach(b => b.addEventListener('click', () => toggleLayer(search, false)));

  const drawer = $('[data-cart-drawer]');
  let cartDrawerRefreshSeq = 0;
  $$('[data-cart-open]').forEach(b => b.addEventListener('click', async () => { toggleLayer(drawer, true); await refreshCartDrawer(); }));
  $$('[data-cart-close]').forEach(b => b.addEventListener('click', () => toggleLayer(drawer, false)));

  const wishlistModal = $('[data-wishlist-modal]');
  $$('[data-wishlist-open]').forEach(link => link.addEventListener('click', e => {
    e.preventDefault();
    renderWishlist();
    toggleLayer(wishlistModal, true);
    if (location.hash !== '#wishlist') history.replaceState(null, '', `${location.pathname}${location.search}#wishlist`);
  }));
  $$('[data-wishlist-close]').forEach(b => b.addEventListener('click', () => {
    toggleLayer(wishlistModal, false);
    if (location.hash === '#wishlist') history.replaceState(null, '', `${location.pathname}${location.search}`);
  }));

  const mixedCartModal = $('[data-mixed-cart-modal]');
  const closeMixedCartModal = () => toggleLayer(mixedCartModal, false);
  $$('[data-mixed-cart-close]').forEach(btn => btn.addEventListener('click', closeMixedCartModal));
  $$('[data-open-mixed-cart]').forEach(btn => btn.addEventListener('click', event => {
    event.preventDefault();
    openMixedCartModal('Pre-order items and regular items cannot be checked out together. Please remove one type before continuing.');
  }));

  function openMixedCartModal(message) {
    const node = $('[data-mixed-cart-message]');
    if (node && message) node.textContent = message;
    toggleLayer(mixedCartModal, true);
  }

  const isPreorderLineItem = (item) => {
    const props = item?.properties || {};
    return String(props._preorder || '').toLowerCase() === 'true' ||
      String(props['Order type'] || props['order type'] || '').toLowerCase() === 'pre-order';
  };

  const isPreorderForm = (formData, form) => String(formData.get('properties[_preorder]') || '').toLowerCase() === 'true' ||
    String(formData.get('properties[Order type]') || formData.get('properties[order type]') || '').toLowerCase() === 'pre-order' ||
    String(form?.dataset?.preorderProduct || '').toLowerCase() === 'true';

  const cartContainsMixedModes = (cart) => {
    const hasPreorder = cart?.items?.some(isPreorderLineItem);
    const hasRegular = cart?.items?.some(item => !isPreorderLineItem(item));
    return Boolean(hasPreorder && hasRegular);
  };

  const lockedSaleCartItem = (cart) => {
    const now = Math.floor(Date.now() / 1000);
    return (cart?.items || []).find(item => {
      const ts = Number(item?.properties?._sale_start_ts || 0);
      return Number.isFinite(ts) && ts > now;
    });
  };

  const lockedSaleMessage = (item) => {
    const title = item?.product_title || 'This item';
    const starts = item?.properties?._sale_start || 'the scheduled sale time';
    return `${title} cannot be checked out until ${starts}. You can keep it in your cart.`;
  };

  function syncCheckoutRestrictions(cart) {
    const lockedItem = lockedSaleCartItem(cart);
    const saleWarning = $('[data-cart-sale-warning]');
    if (saleWarning) {
      saleWarning.textContent = lockedItem ? lockedSaleMessage(lockedItem) : '';
      saleWarning.hidden = !lockedItem;
    }
    const footer = $('[data-cart-drawer-footer]');
    if (footer) {
      const checkoutAction = footer.querySelector('[href="/checkout"], [href$="/checkout"], [data-sale-checkout-blocked], [data-open-mixed-cart]');
      if (checkoutAction && lockedItem) {
        const blocked = document.createElement('button');
        blocked.className = 'button button-dark full-width';
        blocked.type = 'button';
        blocked.disabled = true;
        blocked.dataset.saleCheckoutBlocked = 'true';
        blocked.textContent = 'Checkout Unavailable';
        checkoutAction.replaceWith(blocked);
      } else if (checkoutAction?.dataset.saleCheckoutBlocked === 'true' && !lockedItem) {
        if (cartContainsMixedModes(cart)) {
          const button = document.createElement('button');
          button.className = 'button button-dark full-width';
          button.type = 'button';
          button.dataset.openMixedCart = 'true';
          button.textContent = 'Checkout';
          button.addEventListener('click', event => {
            event.preventDefault();
            openMixedCartModal('Pre-order items and regular items cannot be checked out together. Please remove one type before continuing.');
          });
          checkoutAction.replaceWith(button);
        } else {
          const link = document.createElement('a');
          link.className = 'button button-dark full-width';
          link.href = '/checkout';
          link.textContent = 'Checkout';
          checkoutAction.replaceWith(link);
        }
      }
    }
    return lockedItem;
  }

  const cartHasOppositeMode = (cart, isPreorderCandidate) => {
    if (!cart?.items?.length) return false;
    return isPreorderCandidate
      ? cart.items.some(item => !isPreorderLineItem(item))
      : cart.items.some(isPreorderLineItem);
  };

  async function enforceCartModeForAdd(isPreorderCandidate) {
    const cart = await getCart();
    if (cartContainsMixedModes(cart)) {
      openMixedCartModal('Your bag already contains both preorder and regular items. Please remove one type before continuing.');
      return false;
    }
    if (cartHasOppositeMode(cart, isPreorderCandidate)) {
      openMixedCartModal(isPreorderCandidate
        ? 'This preorder item cannot be added because your bag already has regular in-stock items.'
        : 'This regular item cannot be added because your bag already has preorder items.');
      return false;
    }
    return true;
  }

  async function getCart() {
    const res = await fetch(`/cart.js?_=${Date.now()}`, {
      headers:{Accept:'application/json'},
      cache:'no-store'
    });
    return res.json();
  }

  const inventoryMap = new Map();
  const inventoryLimitRequests = new Map();
  const normalizeInventoryMax = (value) => {
    const n = Number(value);
    return Number.isFinite(n) && n >= 0 ? n : null;
  };
  function seedInventoryMap(root = document) {
    const json = $('[data-cart-inventory-map]', root);
    if (json) {
      try {
        const values = JSON.parse(json.textContent || '{}');
        Object.entries(values).forEach(([variantId, value]) => {
          const max = normalizeInventoryMax(value);
          if (max !== null) inventoryMap.set(String(variantId), max);
        });
      } catch (_) {}
    }
    $$('[data-inventory-source]', root).forEach(source => {
      const max = normalizeInventoryMax(source.dataset.inventoryMax);
      const variantId = source.dataset.variantId;
      if (variantId && max !== null) inventoryMap.set(String(variantId), max);
    });
  }
  seedInventoryMap();

  async function resolveCartInventoryLimit(item) {
    const variantId = String(item.variant_id || '');
    if (!variantId) return null;
    if (inventoryMap.has(variantId)) return inventoryMap.get(variantId);
    if (inventoryLimitRequests.has(variantId)) return inventoryLimitRequests.get(variantId);

    // A cart response does not include inventory. Load it once from the product
    // JSON so the quantity control still has a limit after an Ajax cart update.
    const request = (async () => {
      try {
        const productUrl = new URL(item.url, window.location.origin);
        const response = await fetch(`${productUrl.pathname}.js`, {headers:{Accept:'application/json'}, cache:'no-store'});
        let max = null;
        if (response.ok) {
          const product = await response.json();
          const variant = product.variants?.find(candidate => String(candidate.id) === variantId);
          max = variant?.inventory_management ? normalizeInventoryMax(variant.inventory_quantity) : null;
        }
        if (max === null) {
          // The Ajax product response can omit inventory on some storefronts.
          // The product page still renders the configured storefront limit.
          const productPage = await fetch(productUrl.pathname, {headers:{Accept:'text/html'}, cache:'no-store'});
          if (productPage.ok) {
            const page = new DOMParser().parseFromString(await productPage.text(), 'text/html');
            const option = Array.from(page.querySelectorAll('[data-variant-select] option'))
              .find(candidate => String(candidate.value) === variantId);
            const source = Array.from(page.querySelectorAll('[data-inventory-source]'))
              .find(candidate => String(candidate.dataset.variantId) === variantId);
            max = normalizeInventoryMax(option?.dataset.inventoryMax ?? source?.dataset.inventoryMax);
          }
        }
        if (max !== null) inventoryMap.set(variantId, max);
        return max;
      } catch (_) {
        return null;
      }
    })();
    inventoryLimitRequests.set(variantId, request);
    return request;
  }

  async function limitCartAddToInventory(formData, form) {
    const variantId = String(formData.get('id') || '');
    const max = inventoryMap.has(variantId) ? inventoryMap.get(variantId) : null;
    if (max === null) return;
    if (max <= 0) throw new Error('This item is out of stock.');

    const cart = await getCart();
    const alreadyInCart = cart.items
      .filter(item => String(item.variant_id) === variantId)
      .reduce((sum, item) => sum + Number(item.quantity || 0), 0);
    const remaining = Math.max(0, max - alreadyInCart);
    if (remaining <= 0) throw new Error(`Only ${max} available and all available stock is already in your bag.`);

    const requested = Math.min(Math.max(1, Number(formData.get('quantity') || 1)), remaining);
    formData.set('quantity', String(requested));
    const input = $('[data-qty-input]', form);
    if (input) input.value = String(requested);
  }

  function setCartError(message = '') {
    const error = $('[data-cart-error]');
    if (!error) return;
    error.textContent = message;
    error.hidden = !message;
  }

  function animateCartSuccess(button) {
    if (button) {
      button.classList.remove('is-adding');
      button.classList.add('is-added');
      setTimeout(() => button.classList.remove('is-added'), 650);
    }
    $$('[data-cart-open]').forEach(cartButton => {
      cartButton.classList.remove('cart-bump');
      void cartButton.offsetWidth;
      cartButton.classList.add('cart-bump');
      setTimeout(() => cartButton.classList.remove('cart-bump'), 650);
    });
  }

  async function flyProductToCart(button) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const target = $('[data-cart-open]');
    if (!target) return;
    const scope = button?.closest('.product-card') || button?.closest('[data-product-root]') || document;
    const source = $('.gallery-slide.active img', scope) || $('.product-card-media img', scope) || $('img', scope);
    if (!source) return;
    const from = source.getBoundingClientRect();
    const to = target.getBoundingClientRect();
    if (!from.width || !from.height || !to.width) return;
    const flyer = source.cloneNode(true);
    flyer.className = 'cart-fly-image';
    flyer.style.left = `${from.left}px`;
    flyer.style.top = `${from.top}px`;
    flyer.style.width = `${Math.min(from.width, 150)}px`;
    flyer.style.height = `${Math.min(from.height, 150)}px`;
    document.body.appendChild(flyer);
    const startX = from.left;
    const startY = from.top;
    const endX = to.left + (to.width / 2) - (Math.min(from.width, 150) / 2);
    const endY = to.top + (to.height / 2) - (Math.min(from.height, 150) / 2);
    const animation = flyer.animate([
      {transform:'translate3d(0,0,0) scale(1)',opacity:1,offset:0},
      {transform:`translate3d(${(endX-startX)*.55}px,${(endY-startY)*.25-55}px,0) scale(.58)`,opacity:.95,offset:.52},
      {transform:`translate3d(${endX-startX}px,${endY-startY}px,0) scale(.12)`,opacity:.18,offset:1}
    ], {duration:650,easing:'cubic-bezier(.22,.7,.2,1)',fill:'forwards'});
    try { await animation.finished; } catch (_) {}
    flyer.remove();
  }

  function showCartAddSkeleton() {
    const body = $('[data-cart-drawer-body]');
    if (!body) return;
    body.querySelectorAll('[data-cart-add-skeleton]').forEach(item => item.remove());
    const skeleton = document.createElement('article');
    skeleton.className = 'drawer-item cart-add-skeleton';
    skeleton.dataset.cartAddSkeleton = 'true';
    skeleton.setAttribute('aria-label', 'Adding product to cart');
    skeleton.innerHTML = `
      <span class="cart-skeleton-box cart-skeleton-image" aria-hidden="true"></span>
      <span class="cart-skeleton-copy" aria-hidden="true">
        <span class="cart-skeleton-box cart-skeleton-title"></span>
        <span class="cart-skeleton-box cart-skeleton-meta"></span>
        <span class="cart-skeleton-box cart-skeleton-actions"></span>
      </span>`;
    if (body.querySelector('.drawer-empty, .drawer-loading')) body.innerHTML = '';
    body.prepend(skeleton);
  }

  function showOptimisticCartItem(form, formData = new FormData(form)) {
    const body = $('[data-cart-drawer-body]');
    if (!body) return;
    const scope = form.closest('.product-card') || form.closest('[data-product-root]') || form.parentElement;
    const titleNode = $('.product-card-title', scope) || $('.product-info h1', scope);
    const imageNode = $('.gallery-slide.active img', scope) || $('.product-image-primary img', scope) || $('.product-card-media img', scope);
    const priceNode = $('.product-card-price span', scope) || $('[data-preorder-advance]', scope) || $('[data-product-price] strong', scope);
    const title = titleNode?.textContent?.trim();
    if (!title) {
      showCartAddSkeleton();
      return;
    }
    const quantity = Math.max(1, Number(formData.get('quantity') || 1));
    const variantSelect = $('[data-variant-select]', form);
    const selectedOption = variantSelect?.selectedOptions?.[0];
    const variant = selectedOption ? selectedOption.textContent.split('·')[0].trim() : '';
    const isPreorder = String(formData.get('properties[_preorder]') || '').toLowerCase() === 'true' ||
      String(formData.get('properties[Order type]') || '').toLowerCase() === 'pre-order';
    const productUrl = titleNode?.closest('a')?.href || $('.product-card-media', scope)?.href || location.href;
    const imageUrl = imageNode?.currentSrc || imageNode?.src || '';
    const price = selectedOption?.dataset.price || priceNode?.textContent?.trim() || '';
    body.querySelectorAll('[data-cart-add-skeleton],[data-cart-optimistic-item]').forEach(item => item.remove());
    if (body.querySelector('.drawer-empty, .drawer-loading')) body.innerHTML = '';
    const item = document.createElement('article');
    item.className = 'drawer-item cart-optimistic-item';
    item.dataset.cartOptimisticItem = 'true';
    item.innerHTML = `
      <a href="${escapeHtml(productUrl)}" class="drawer-item-image">${imageUrl ? `<img src="${escapeHtml(imageUrl)}" alt="">` : ''}</a>
      <div>
        <a href="${escapeHtml(productUrl)}"><strong>${escapeHtml(title)}</strong></a>
        <span class="drawer-item-meta">
          ${variant && variant !== 'Default Title' ? `<span>${escapeHtml(variant)}</span>` : ''}
          ${isPreorder ? '<span class="preorder-label">Pre-Order</span>' : ''}
        </span>
        <div class="drawer-item-row">
          <strong>${escapeHtml(price)}</strong>
          <span class="cart-optimistic-quantity">Qty ${quantity}</span>
          <span class="cart-optimistic-status">Adding…</span>
        </div>
      </div>`;
    body.prepend(item);
  }

  async function changeCartLine(key, quantity) {
    setCartError('');
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json', Accept:'application/json'},
        body: JSON.stringify({id:key, quantity})
      });
      if (!res.ok) {
        let message = 'Unable to update quantity.';
        try { const data = await res.json(); message = data.description || data.message || message; } catch (_) {}
        throw new Error(message);
      }
      await refreshCartDrawer();
    } catch (error) {
      setCartError(error.message || 'Unable to update quantity.');
    }
  }

  async function refreshCartDrawer() {
    const refreshSeq = ++cartDrawerRefreshSeq;
    const body = $('[data-cart-drawer-body]');
    const footer = $('[data-cart-drawer-footer]');
    if (!body) return;
    try {
      const cart = await getCart();
      if (refreshSeq !== cartDrawerRefreshSeq) return;
      // Inventory lookup enriches the quantity controls, but it must never
      // leave a successful add-to-cart operation waiting indefinitely.
      const inventoryResolution = Promise.all(cart.items.map(resolveCartInventoryLimit));
      const inventoryResolved = await Promise.race([
        inventoryResolution.then(() => true).catch(() => true),
        new Promise(resolve => setTimeout(() => resolve(false), 750))
      ]);
      if (!inventoryResolved) {
        inventoryResolution.then(() => {
          if (refreshSeq === cartDrawerRefreshSeq) refreshCartDrawer();
        }).catch(() => {});
      }
      if (refreshSeq !== cartDrawerRefreshSeq) return;
      setCartError('');
      $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
      if (!cart.items.length) {
        body.innerHTML = '<div class="drawer-empty"><p>Your bag is empty.</p><a class="button button-dark full-width" href="/collections/all">Browse Models</a></div>';
        if (footer) footer.hidden = true;
        return;
      }
      body.innerHTML = cart.items.map(item => {
        const max = inventoryMap.has(String(item.variant_id)) ? inventoryMap.get(String(item.variant_id)) : null;
        const atMax = max !== null && item.quantity >= max;
        const lowStock = max !== null && max > 0 && max < 5;
        const isPreorder = String(item.properties?._preorder || '').toLowerCase() === 'true' ||
          String(item.properties?.['Order type'] || '').toLowerCase() === 'pre-order';
        const saleStartTs = Number(item.properties?._sale_start_ts || 0);
        const saleLocked = Number.isFinite(saleStartTs) && saleStartTs > Math.floor(Date.now() / 1000);
        const saleStartLabel = item.properties?._sale_start || '';
        const preorderBalanceCents = isPreorder ? preorderPendingCents(item) : 0;
        const preorderTotalCents = item.final_line_price + (preorderBalanceCents * item.quantity);
        const variantLabel = item.variant_title && item.variant_title !== 'Default Title' ? escapeHtml(item.variant_title) : '';
        return `
        <article class="drawer-item">
          <a href="${item.url}" class="drawer-item-image">${item.image ? `<img src="${item.image}" alt="">` : ''}</a>
          <div>
            <a href="${item.url}"><strong>${escapeHtml(item.product_title)}</strong></a>
            <span class="drawer-item-meta">
              ${variantLabel ? `<span>${variantLabel}</span>` : ''}
              ${isPreorder ? '<span class="preorder-label">Pre-Order</span>' : ''}
            </span>
            ${lowStock ? `<span class="drawer-low-stock">Low stock — only ${max} left</span>` : ''}
            ${saleLocked && saleStartLabel ? `<span class="cart-sale-start-note">Sale starts ${escapeHtml(saleStartLabel)}</span>` : ''}
            <div class="drawer-item-row">
              ${isPreorder && preorderTotalCents > item.final_line_price ? `
                <div class="cart-preorder-price" aria-label="Book at ${moneyCompact(item.final_line_price)} of ${moneyCompact(preorderTotalCents)}">
                  <span class="preorder-card-price-label">Book at</span>
                  <span class="preorder-card-price-line"><strong data-drawer-line-price data-preorder-balance-cents="${preorderBalanceCents}">${moneyCompact(item.final_line_price)}</strong><span class="preorder-card-price-total">of <span data-drawer-preorder-total>${moneyCompact(preorderTotalCents)}</span></span></span>
                </div>
              ` : `<strong data-drawer-line-price>${money(item.final_line_price)}</strong>`}
              <div class="drawer-quantity" data-cart-drawer-qty data-line-key="${escapeHtml(item.key)}" data-variant-id="${item.variant_id}" data-quantity="${item.quantity}" data-unit-price="${item.final_price}" data-max="${max === null ? -1 : max}">
                <button type="button" data-cart-drawer-minus aria-label="Decrease quantity"${item.quantity <= 1 ? ' disabled' : ''}>−</button>
                <span>${item.quantity}</span>
                <button type="button" data-cart-drawer-plus aria-label="Increase quantity"${atMax ? ' disabled' : ''}>+</button>
              </div>
              <button class="drawer-remove" type="button" data-remove-line="${escapeHtml(item.key)}" aria-label="Remove ${escapeHtml(item.product_title)}">
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3m3 0-1 13H7L6 7m4 4v5m4-5v5"/></svg>
              </button>
            </div>
          </div>
        </article>`;
      }).join('');

      const drawerSubtotal = $('[data-cart-subtotal]');
      if (drawerSubtotal) drawerSubtotal.dataset.totalCents = String(cart.total_price);
      syncCheckoutRestrictions(cart);

      $$('[data-cart-drawer-qty]', body).forEach(control => {
        const minus = $('[data-cart-drawer-minus]', control);
        const plus = $('[data-cart-drawer-plus]', control);
        const count = $('span', control);
        const row = control.closest('.drawer-item-row');
        const price = $('[data-drawer-line-price]', row);
        const preorderTotal = $('[data-drawer-preorder-total]', row);
        let max = normalizeInventoryMax(control.dataset.max);
        const unitPrice = Number(control.dataset.unitPrice || 0);
        const preorderBalanceCents = Number(price?.dataset.preorderBalanceCents || 0);
        let confirmed = Math.max(1, Number(control.dataset.quantity || 1));
        let target = confirmed;
        let requestInFlight = false;
        let commitTimer = null;

        const render = (next, adjustTotals = true) => {
          const previous = target;
          const value = Math.max(1, max === null ? next : Math.min(next, max));
          target = value;
          control.dataset.quantity = String(value);
          if (count) count.textContent = String(value);
          if (minus) minus.disabled = value <= 1;
          if (plus) plus.disabled = max !== null && value >= max;
          if (price) price.textContent = preorderBalanceCents > 0 ? moneyCompact(unitPrice * value) : money(unitPrice * value);
          if (preorderTotal) preorderTotal.textContent = moneyCompact((unitPrice + preorderBalanceCents) * value);
          if (adjustTotals && value !== previous) {
            const delta = value - previous;
            if (drawerSubtotal) {
              const nextTotal = Number(drawerSubtotal.dataset.totalCents || cart.total_price) + (unitPrice * delta);
              drawerSubtotal.dataset.totalCents = String(nextTotal);
              drawerSubtotal.textContent = money(nextTotal);
            }
            $$('[data-cart-count]').forEach(el => {
              const nextCount = Math.max(0, Number(el.textContent || cart.item_count) + delta);
              el.textContent = String(nextCount);
              el.hidden = nextCount === 0;
            });
          }
          return value;
        };

        const commit = async () => {
          if (requestInFlight || target === confirmed) return;
          const sent = target;
          requestInFlight = true;
          setCartError('');
          try {
            const response = await fetch('/cart/change.js', {
              method:'POST',
              headers:{'Content-Type':'application/json',Accept:'application/json'},
              body:JSON.stringify({id:control.dataset.lineKey,quantity:sent})
            });
            if (!response.ok) {
              let message = 'Unable to update quantity.';
              try { const payload = await response.json(); message = payload.description || payload.message || message; } catch (_) {}
              const error = new Error(message);
              error.status = response.status;
              throw error;
            }
            const updatedCart = await response.json();
            const updatedItem = updatedCart.items.find(item => item.key === control.dataset.lineKey);
            const actual = Math.max(1, Number(updatedItem?.quantity || sent));
            confirmed = actual;
            if (actual < sent) {
              max = actual;
              control.dataset.max = String(actual);
              if (control.dataset.variantId) inventoryMap.set(String(control.dataset.variantId), actual);
            }
            if (target === sent) {
              if (actual !== target) render(actual);
              if (drawerSubtotal) {
                drawerSubtotal.dataset.totalCents = String(updatedCart.total_price);
                drawerSubtotal.textContent = money(updatedCart.total_price);
              }
              $$('[data-cart-count]').forEach(el => {
                el.textContent = String(updatedCart.item_count);
                el.hidden = updatedCart.item_count === 0;
              });
            }
          } catch (error) {
            // Shopify uses 422 when its inventory rule rejects an increase.
            // The confirmed cart quantity is then the authoritative ceiling for
            // this customer session, even if storefront inventory was omitted.
            if (error.status === 422) {
              max = confirmed;
              control.dataset.max = String(confirmed);
              if (control.dataset.variantId) inventoryMap.set(String(control.dataset.variantId), confirmed);
              if (plus) plus.disabled = true;
            }
            if (target === sent) render(confirmed);
            setCartError(error.message || 'Unable to update quantity.');
          } finally {
            requestInFlight = false;
            if (target !== confirmed) {
              clearTimeout(commitTimer);
              commitTimer = setTimeout(commit, 60);
            }
          }
        };

        const update = (next) => {
          const value = render(next);
          if (value === confirmed && !requestInFlight) return;
          clearTimeout(commitTimer);
          commitTimer = setTimeout(commit, 90);
        };

        minus?.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          update(target - 1);
        });
        plus?.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          if (max !== null && target >= max) {
            plus.disabled = true;
            return;
          }
          update(target + 1);
        });
        render(target, false);
      });
      $$('[data-remove-line]', body).forEach(btn => btn.addEventListener('click', () => {
        const item = btn.closest('.drawer-item');
        if (item) {
          item.classList.add('is-removing');
          const remainingItems = $$('.drawer-item:not(.is-removing)', body);
          setTimeout(() => item.remove(), 180);
          if (!remainingItems.length) {
            setTimeout(() => {
              body.innerHTML = '<div class="drawer-empty"><p>Your bag is empty.</p><a class="button button-dark full-width" href="/collections/all">Browse Models</a></div>';
              if (footer) footer.hidden = true;
            }, 180);
          }
        }
        changeCartLine(btn.dataset.removeLine, 0);
      }));
      $('[data-cart-subtotal]').textContent = money(cart.total_price);
      if (footer) footer.hidden = false;
    } catch (e) { body.innerHTML = '<p>Unable to load the cart. Please open the cart page.</p>'; }
  }

  function syncProductQuantity(input) {
    if (!input) return;
    const min = Math.max(1, Number(input.min || 1));
    const max = input.hasAttribute('max') ? Number(input.max) : null;
    let value = Math.max(min, Number(input.value || min));
    if (max !== null && Number.isFinite(max)) value = Math.min(value, Math.max(min, max));
    input.value = value;
    const control = input.closest('.quantity-control');
    const minus = $('[data-qty-minus]', control);
    const plus = $('[data-qty-plus]', control);
    if (minus) minus.disabled = value <= min;
    if (plus) plus.disabled = max !== null && Number.isFinite(max) && value >= max;
  }

  $$('.product-form').forEach(form => {
    form.dataset.cartBound = 'true';
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const button = $('[data-add-to-cart]', form);
      if (button?.disabled) return;
      const label = button.textContent;
      const data = new FormData(form);
      const preorderCandidate = isPreorderForm(data, form);
      if (!(await enforceCartModeForAdd(preorderCandidate))) return;
      button.disabled = true; button.textContent = 'Adding…'; button.classList.add('is-adding');
      showOptimisticCartItem(form, data);
      const flyPromise = flyProductToCart(button);
      flyPromise.then(() => {
        if (button.textContent === 'Adding…') button.textContent = 'Added ✓';
        if (drawer) toggleLayer(drawer, true);
      });
      try {
        await limitCartAddToInventory(data, form);
        const res = await fetch('/cart/add.js', {method:'POST', headers:{Accept:'application/json'}, body:data});
        if (!res.ok) {
          let message = 'Unable to add this quantity.';
          try { const payload = await res.json(); message = payload.description || payload.message || message; } catch (_) {}
          throw new Error(message);
        }
        const drawerRefresh = refreshCartDrawer();
        await flyPromise;
        animateCartSuccess(button);
        await drawerRefresh;
        setTimeout(() => { button.textContent = label; }, 650);
      } catch (err) {
        button.textContent = 'Stock Limit';
        setCartError(err.message || 'Unable to add this quantity.');
        if (drawer) { toggleLayer(drawer, true); await refreshCartDrawer(); setCartError(err.message || 'Unable to add this quantity.'); }
        setTimeout(() => button.textContent = label, 1800);
      }
      finally { button.disabled = false; button.classList.remove('is-adding'); if (button.textContent === 'Adding…') button.textContent = label; }
    });
  });

  // Product forms appended by infinite scrolling use delegated quick-add.
  document.addEventListener('submit', async event => {
    const form = event.target.closest('.product-form');
    if (!form || form.dataset.cartBound === 'true') return;
    event.preventDefault();
    const button = $('[data-add-to-cart]', form);
    if (button?.disabled) return;
    const label = button?.textContent || 'Add to Cart';
    const data = new FormData(form);
    const preorderCandidate = isPreorderForm(data, form);
    if (!(await enforceCartModeForAdd(preorderCandidate))) return;
    if (button) { button.disabled = true; button.textContent = 'Adding…'; button.classList.add('is-adding'); }
    showOptimisticCartItem(form, data);
    const flyPromise = flyProductToCart(button);
    flyPromise.then(() => {
      if (button && button.textContent === 'Adding…') button.textContent = 'Added ✓';
      if (drawer) toggleLayer(drawer, true);
    });
    try {
      await limitCartAddToInventory(data, form);
      const response = await fetch('/cart/add.js', {
        method:'POST',
        headers:{Accept:'application/json'},
        body:data
      });
      if (!response.ok) {
        let message = 'Unable to add this item.';
        try { const payload = await response.json(); message = payload.description || payload.message || message; } catch (_) {}
        throw new Error(message);
      }
      const drawerRefresh = refreshCartDrawer();
      await flyPromise;
      animateCartSuccess(button);
      await drawerRefresh;
      if (button) setTimeout(() => { button.textContent = label; }, 650);
    } catch (error) {
      setCartError(error.message || 'Unable to add this item.');
      toggleLayer(drawer, true);
    } finally {
      if (button) { button.disabled = false; button.textContent = label; button.classList.remove('is-adding'); }
    }
  });

  $$('[data-preorder-now]').forEach(button => button.addEventListener('click', async () => {
    const form = button.closest('.product-form');
    if (!form || button.disabled) return;
    const original = button.textContent;
    button.disabled = true;
    button.textContent = 'Preparing…';
    try {
      const data = new FormData(form);
      if (!(await enforceCartModeForAdd(true))) {
        button.textContent = original;
        button.disabled = false;
        return;
      }
      const saleStartTs = Number(data.get('properties[_sale_start_ts]') || 0);
      const saleStartLabel = data.get('properties[_sale_start]') || 'the scheduled sale time';
      const variantId = String(data.get('id') || '');
      let requested = Math.max(1, Number(data.get('quantity') || 1));
      const max = inventoryMap.has(variantId) ? inventoryMap.get(variantId) : null;
      if (max !== null) {
        const currentCart = await getCart();
        const alreadyInCart = currentCart.items.filter(item => String(item.variant_id) === variantId).reduce((sum, item) => sum + Number(item.quantity || 0), 0);
        const remaining = Math.max(0, max - alreadyInCart);
        if (remaining <= 0) throw new Error(`Only ${max} available and all available stock is already in your bag.`);
        requested = Math.min(requested, remaining);
        data.set('quantity', String(requested));
      }
      const res = await fetch('/cart/add.js', {method:'POST', headers:{Accept:'application/json'}, body:data});
      if (!res.ok) {
        let message = 'Unable to add this pre-order.';
        try { const payload = await res.json(); message = payload.description || payload.message || message; } catch (_) {}
        throw new Error(message);
      }
      if (Number.isFinite(saleStartTs) && saleStartTs > Math.floor(Date.now() / 1000)) {
        throw new Error(`This item cannot be checked out until ${saleStartLabel}. You can keep it in your cart.`);
      }
      window.location.assign('/checkout');
    } catch (err) {
      button.textContent = 'Try Again';
      if (drawer) { toggleLayer(drawer, true); await refreshCartDrawer(); setCartError(err.message || 'Unable to continue to checkout.'); }
      setTimeout(() => { button.textContent = original; button.disabled = false; }, 1800);
      return;
    }
  }));

  $$('[data-mobile-preorder-now]').forEach(button => button.addEventListener('click', () => $('[data-preorder-now]')?.click()));

  $$('[data-mobile-add]').forEach(button => button.addEventListener('click', () => $('[data-add-to-cart]')?.click()));
  $$('[data-product-root][data-sale-locked="true"][data-sale-start-ts]').forEach(root => {
    const saleStartMs = Number(root.dataset.saleStartTs || 0) * 1000;
    const wait = saleStartMs - Date.now();
    if (!Number.isFinite(wait)) return;
    if (wait <= 0) {
      window.location.reload();
      return;
    }
    window.setTimeout(() => window.location.reload(), Math.min(wait + 1000, 2147483647));
  });
  $$('[data-qty-input]').forEach(input => {
    syncProductQuantity(input);
    input.addEventListener('input', () => syncProductQuantity(input));
    input.addEventListener('change', () => syncProductQuantity(input));
  });
  $$('[data-qty-minus]').forEach(btn => btn.addEventListener('click', () => {
    const input = $('[data-qty-input]', btn.closest('.product-form'));
    input.value = Math.max(1, Number(input.value || 1) - 1);
    syncProductQuantity(input);
  }));
  $$('[data-qty-plus]').forEach(btn => btn.addEventListener('click', () => {
    const input = $('[data-qty-input]', btn.closest('.product-form'));
    const max = input.hasAttribute('max') ? Number(input.max) : null;
    const next = Number(input.value || 1) + 1;
    input.value = max !== null && Number.isFinite(max) ? Math.min(next, max) : next;
    syncProductQuantity(input);
  }));

  $$('[data-gallery-thumb]').forEach(btn => btn.addEventListener('click', () => {
    const root = btn.closest('[data-product-gallery]');
    $$('[data-gallery-thumb]', root).forEach(x => x.classList.toggle('active', x === btn));
    $$('[data-gallery-slide]', root).forEach(x => x.classList.toggle('active', x.dataset.gallerySlide === btn.dataset.galleryThumb));
  }));

  $$('[data-variant-select]').forEach(select => select.addEventListener('change', () => {
    const opt = select.options[select.selectedIndex];
    const root = select.closest('[data-product-root]');
    const form = select.closest('.product-form');
    const price = $('[data-product-price] strong', root); if (price) price.textContent = opt.dataset.price || price.textContent;
    const preorderAdvance = $('[data-preorder-advance]', root);
    if (preorderAdvance) preorderAdvance.textContent = opt.dataset.priceCompact || opt.dataset.price || preorderAdvance.textContent;
    const preorderBooking = $('[data-preorder-booking]', root);
    if (preorderBooking) preorderBooking.textContent = opt.dataset.price || preorderBooking.textContent;
    const preorderTotal = $('[data-preorder-total]', root);
    if (preorderTotal) preorderTotal.textContent = opt.dataset.totalPrice || preorderTotal.textContent;
    const preorderNow = $('[data-preorder-now]', root);
    const mobilePreorderNow = $('[data-mobile-preorder-now]');
    const reserveLabel = opt.dataset.reserveLabel || (opt.dataset.priceCompact ? `Reserve Now — Pay ${opt.dataset.priceCompact}` : '');
    const saleLocked = root?.dataset.saleLocked === 'true' || form?.dataset.saleLocked === 'true';
    const saleStartInput = form ? $('[name="properties[_sale_start]"]', form) : null;
    const saleStartLabel = saleStartInput?.value || '';
    if (preorderNow && reserveLabel) {
      preorderNow.textContent = saleLocked && saleStartLabel ? `Sale Starts ${saleStartLabel}` : reserveLabel;
      preorderNow.disabled = saleLocked || opt.dataset.available !== 'true';
    }
    if (mobilePreorderNow && reserveLabel) {
      mobilePreorderNow.textContent = saleLocked && saleStartLabel ? `Sale Starts ${saleStartLabel}` : reserveLabel;
      mobilePreorderNow.disabled = saleLocked || opt.dataset.available !== 'true';
    }
    const preorderActualRow = $('[data-preorder-actual-row]', root);
    const preorderActual = $('[data-preorder-actual]', root);
    if (preorderActualRow) {
      const compareAt = opt.dataset.compareAtPrice || '';
      preorderActualRow.hidden = !compareAt;
      if (preorderActual) preorderActual.textContent = compareAt;
    }
    const max = normalizeInventoryMax(opt.dataset.inventoryMax);
    const add = $('[data-add-to-cart]', root);
    const available = opt.dataset.available === 'true' && (max === null || max > 0);
    if (add) { add.disabled = !available; add.textContent = available ? (add.textContent.includes('Reserve') ? 'Reserve Now' : 'Add to Cart') : 'Sold Out'; }
    const mobileAdd = $('[data-mobile-add]');
    if (mobileAdd) { mobileAdd.disabled = !available; mobileAdd.textContent = available ? 'Add to Cart' : 'Sold Out'; }
    const productTrust = $('[data-product-trust]', root);
    if (productTrust) productTrust.hidden = !available;

    const source = $('[data-inventory-source]', form);
    if (source) { source.dataset.variantId = opt.value; source.dataset.inventoryMax = max === null ? '-1' : String(max); }
    if (max !== null) inventoryMap.set(String(opt.value), max);

    const input = $('[data-qty-input]', form);
    if (input) {
      if (max !== null) input.max = String(max); else input.removeAttribute('max');
      input.value = '1';
      syncProductQuantity(input);
    }
    const status = $('[data-inventory-status]', root);
    const count = $('[data-inventory-count]', status || root);
    if (status) {
      const low = available && max !== null && max > 0 && max < 5;
      status.hidden = !low;
      if (count && low) count.textContent = String(max);
    }
    const availableCount = $('[data-inventory-available]', root);
    if (availableCount) {
      availableCount.hidden = max === null;
      if (max !== null) availableCount.textContent = `${Math.max(0, max)} Available`;
    }
  }));

  $$('[data-cart-page-qty]').forEach(control => {
    const input = $('input[name="updates[]"]', control);
    const minus = $('[data-cart-page-minus]', control);
    const plus = $('[data-cart-page-plus]', control);
    const max = normalizeInventoryMax(control.dataset.max);
    const line = control.closest('.cart-line');
    const linePrice = $('[data-cart-line-price]', line);
    const preorderTotal = $('[data-cart-page-preorder-total]', line);
    const subtotal = $('[data-cart-page-subtotal]');
    const unitPrice = Number(control.dataset.unitPrice || 0);
    const preorderBalanceCents = Number(linePrice?.dataset.preorderBalanceCents || 0);
    const pageError = $('[data-cart-page-error]');
    let confirmedValue = Math.max(1, Number(input?.value || 1));
    let displayedValue = confirmedValue;
    let commitTimer = null;
    let requestInFlight = false;
    const sync = () => {
      let value = Math.max(1, Number(input.value || 1));
      if (max !== null) value = Math.min(value, Math.max(1, max));
      input.value = value;
      if (minus) minus.disabled = value <= 1;
      if (plus) plus.disabled = max !== null && value >= max;
      return value;
    };
    const commit = async () => {
      if (requestInFlight || displayedValue === confirmedValue) return;
      const value = displayedValue;
      requestInFlight = true;
      control.classList.add('is-updating');
      if (pageError) pageError.hidden = true;
      try {
        const res = await fetch('/cart/change.js', {
          method:'POST',
          headers:{'Content-Type':'application/json',Accept:'application/json'},
          body:JSON.stringify({id:control.dataset.lineKey || control.dataset.variantId,quantity:value})
        });
        if (!res.ok) {
          let message = 'Unable to update quantity.';
          try { const payload = await res.json(); message = payload.description || payload.message || message; } catch (_) {}
          throw new Error(message);
        }
        const cart = await res.json();
        const updatedItem = cart.items.find(item => item.key === control.dataset.lineKey) ||
          cart.items.find(item => String(item.variant_id) === String(control.dataset.variantId || ''));
        confirmedValue = value;
        if (displayedValue === value) {
          if (updatedItem && linePrice) linePrice.textContent = preorderBalanceCents > 0 ? moneyCompact(updatedItem.final_line_price) : money(updatedItem.final_line_price);
          if (updatedItem && preorderTotal) preorderTotal.textContent = moneyCompact(updatedItem.final_line_price + (preorderBalanceCents * updatedItem.quantity));
          if (subtotal) {
            subtotal.textContent = money(cart.total_price);
            subtotal.dataset.totalCents = String(cart.total_price);
          }
          $$('[data-cart-count]').forEach(el => {
            el.textContent = cart.item_count;
            el.hidden = cart.item_count === 0;
          });
        }
      } catch (error) {
        const rollbackDelta = unitPrice * (confirmedValue - displayedValue);
        displayedValue = confirmedValue;
        input.value = confirmedValue;
        sync();
        if (linePrice) linePrice.textContent = money(unitPrice * confirmedValue);
        if (subtotal) {
          const restoredTotal = Number(subtotal.dataset.totalCents || 0) + rollbackDelta;
          subtotal.textContent = money(restoredTotal);
          subtotal.dataset.totalCents = String(restoredTotal);
        }
        if (pageError) {
          pageError.textContent = error.message || 'Unable to update quantity.';
          pageError.hidden = false;
        }
      } finally {
        requestInFlight = false;
        control.classList.remove('is-updating');
        if (displayedValue !== confirmedValue) {
          clearTimeout(commitTimer);
          commitTimer = setTimeout(commit, 120);
        }
      }
    };
    const update = (nextValue) => {
      const previousDisplayed = displayedValue;
      input.value = nextValue;
      const value = sync();
      if (value === previousDisplayed) return;
      displayedValue = value;
      if (linePrice) linePrice.textContent = money(unitPrice * value);
      if (subtotal) {
        const previousTotal = Number(subtotal.dataset.totalCents || 0);
        const optimisticTotal = previousTotal + (unitPrice * (value - previousDisplayed));
        subtotal.textContent = money(optimisticTotal);
        subtotal.dataset.totalCents = String(optimisticTotal);
      }
      clearTimeout(commitTimer);
      commitTimer = setTimeout(commit, 90);
    };
    minus?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      update(Math.max(1, Number(input.value || 1) - 1));
    });
    plus?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const current = Number(input.value || 1);
      if (max !== null && current >= max) return;
      update(current + 1);
    });
    input?.addEventListener('input', sync);
    input?.addEventListener('change', () => update(Number(input.value || 1)));
    sync();
  });

  $$('.cart-remove-button').forEach(link => link.addEventListener('click', async event => {
    event.preventDefault();
    const line = link.closest('.cart-line');
    const cartItems = line?.closest('.cart-items');
    if (line) {
      line.classList.add('is-removing');
      setTimeout(() => line.remove(), 180);
    }
    try {
      const response = await fetch('/cart/change.js', {
        method:'POST',
        headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify({id:link.dataset.lineKey,quantity:0})
      });
      if (!response.ok) throw new Error('Unable to remove this item.');
      const cart = await response.json();
      const subtotal = $('[data-cart-page-subtotal]');
      if (subtotal) {
        subtotal.textContent = money(cart.total_price);
        subtotal.dataset.totalCents = String(cart.total_price);
      }
      $$('[data-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
    } catch (error) {
      if (line && cartItems && !line.isConnected) cartItems.prepend(line);
      line?.classList.remove('is-removing');
      const pageError = $('[data-cart-page-error]');
      if (pageError) {
        pageError.textContent = error.message || 'Unable to remove this item.';
        pageError.hidden = false;
      }
    }
  }));

  document.addEventListener('click', event => {
    const checkoutLink = event.target.closest('[href="/checkout"], [href$="/checkout"]');
    if (!checkoutLink) return;
    event.preventDefault();
    event.stopPropagation();
    (async () => {
      const cart = await getCart();
      const lockedItem = lockedSaleCartItem(cart);
      if (lockedItem) {
        openMixedCartModal(lockedSaleMessage(lockedItem));
        syncCheckoutRestrictions(cart);
        return;
      }
      if (cartContainsMixedModes(cart)) {
        openMixedCartModal('Pre-order items and regular items cannot be checked out together. Please separate them into different orders.');
        return;
      }
      window.location.assign('/checkout');
    })();
  }, true);

  document.addEventListener('submit', event => {
    const cartForm = event.target.closest('form[action*="/cart"]');
    if (!cartForm || !cartForm.querySelector('button[name="checkout"]')) return;
    event.preventDefault();
    (async () => {
      const cart = await getCart();
      const lockedItem = lockedSaleCartItem(cart);
      if (lockedItem) {
        openMixedCartModal(lockedSaleMessage(lockedItem));
        syncCheckoutRestrictions(cart);
        return;
      }
      if (cartContainsMixedModes(cart)) {
        openMixedCartModal('Pre-order items and regular items cannot be checked out together. Please separate them into different orders.');
        return;
      }
      window.location.assign('/checkout');
    })();
  }, true);

  $$('[data-pin-check]').forEach(btn => btn.addEventListener('click', () => {
    const box = btn.closest('.delivery-check'), input = $('[data-pin-input]', box), result = $('[data-pin-result]', box);
    const valid = /^\d{6}$/.test(input.value.trim());
    result.textContent = valid ? 'Delivery availability and final estimate will be confirmed at checkout.' : 'Enter a valid 6-digit PIN code.';
  }));

  $$('[data-share-button]').forEach(btn => btn.addEventListener('click', async () => {
    const data = {title:btn.dataset.shareTitle || document.title, url:location.href};
    if (navigator.share) {
      try { await navigator.share(data); } catch (_) {}
    } else {
      try {
        await navigator.clipboard.writeText(location.href);
        const label = $('[data-share-label]', btn);
        if (label) {
          label.textContent = 'Link copied';
          setTimeout(() => { label.textContent = 'Share'; }, 1200);
        }
      } catch (_) {}
    }
  }));

  // Wishlist: local browser persistence so the page works without an app.
  const WKEY = 'kdc_wishlist_v1';
  const readWish = () => { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (_) { return []; } };
  const writeWish = (items) => { localStorage.setItem(WKEY, JSON.stringify(items)); updateWishCount(); };
  const updateWishCount = () => { const n = readWish().length; $$('[data-wishlist-count]').forEach(el => {el.textContent=n; el.hidden=n===0;}); };
  function renderWishlist() {
    const grids = $$('[data-wishlist-grid]'); if (!grids.length) return;
    const items = readWish();
    grids.forEach(grid => {
      const scope = grid.closest('.wishlist-modal, .wishlist-page') || document;
      const empty = $('[data-wishlist-empty]', scope);
      if (!items.length) { grid.innerHTML=''; if (empty) empty.hidden=false; return; }
      if (empty) empty.hidden=true;
      grid.innerHTML = items.map(i => `<article class="product-card wishlist-card">
        <div class="product-card-media-wrap wishlist-card-media-wrap">
          <a class="product-card-media" href="${escapeHtml(i.url || '#')}">${i.image ? `<img class="product-image-primary" src="${escapeHtml(i.image)}" alt="${escapeHtml(i.title || '')}" loading="lazy">` : ''}</a>
          <button type="button" class="wishlist-card-remove" aria-label="Remove ${escapeHtml(i.title || 'item')} from wishlist" data-wishlist-remove="${escapeHtml(i.handle || '')}">&times;</button>
        </div>
        <div class="product-card-info">
          <a class="product-card-title" href="${escapeHtml(i.url || '#')}">${escapeHtml(i.title)}</a>
          <div class="product-card-price"><span>${escapeHtml(i.price)}</span></div>
          <p class="product-card-vendor">${escapeHtml(i.vendor || '')}</p>
          <button type="button" class="wishlist-remove" data-wishlist-remove="${escapeHtml(i.handle || '')}">Remove</button>
        </div>
      </article>`).join('');
      $$('[data-wishlist-remove]', grid).forEach(b => b.addEventListener('click', () => { writeWish(readWish().filter(x => x.handle !== b.dataset.wishlistRemove)); renderWishlist(); }));
    });
  }
  window.addEventListener('kdc:account-wishlist-requested', renderWishlist);
  const bindWishlistToggles = (scope = document) => {
    $$('[data-wishlist-toggle]', scope).forEach(btn => {
      if (btn.dataset.wishlistBound === 'true') return;
      btn.dataset.wishlistBound = 'true';
      const exists = readWish().some(x => x.handle === btn.dataset.productHandle); btn.classList.toggle('active', exists);
      btn.addEventListener('click', () => { let items=readWish(), idx=items.findIndex(x=>x.handle===btn.dataset.productHandle); if(idx>=0){items.splice(idx,1);btn.classList.remove('active');}else{items.unshift({handle:btn.dataset.productHandle,title:btn.dataset.productTitle,url:btn.dataset.productUrl,image:btn.dataset.productImage,price:btn.dataset.productPrice,vendor:btn.dataset.productVendor});btn.classList.add('active');} writeWish(items); });
    });
  };
  bindWishlistToggles();
  updateWishCount(); renderWishlist();
  window.addEventListener('kdc:products-updated', event => {
    bindWishlistToggles(event.detail?.root || document);
  });

  // All Models infinite scrolling. Numbered pagination remains in the fetched
  // HTML as a resilient fallback, but is replaced by automatic loading here.
  const isFilteredAllModelsUrl = () => Boolean($('.all-models-page')) && (
    location.search.includes('filter.') ||
    location.search.includes('kdc_filter=') ||
    location.search.includes('sort_by=') ||
    location.search.includes('q=')
  );
  const allModelsReturnKey = 'kdc_all_models_return_url';
  const currentAllModelsReturnUrl = () => `${location.pathname}${location.search}`;
  const rememberAllModelsReturnUrl = () => {
    if (!isFilteredAllModelsUrl()) return;
    try { sessionStorage.setItem(allModelsReturnKey, currentAllModelsReturnUrl()); } catch (_) {}
  };
  const storedAllModelsReturnUrl = () => {
    try { return sessionStorage.getItem(allModelsReturnKey) || ''; } catch (_) { return ''; }
  };
  const preserveAllModelsReturnLinks = (root = document) => {
    if (!$('.all-models-page') || !isFilteredAllModelsUrl()) return;
    rememberAllModelsReturnUrl();
    const returnTo = currentAllModelsReturnUrl();
    $$('[data-product-card] a.product-card-media, [data-product-card] a.product-card-title', root).forEach(link => {
      try {
        const url = new URL(link.href, location.origin);
        if (url.origin !== location.origin) return;
        url.searchParams.set('return_to', returnTo);
        link.href = url.toString();
      } catch (_) {}
    });
  };
  const restoreAllModelsReturnUrl = () => {
    const params = new URLSearchParams(location.search);
    const returnTo = params.get('return_to') || storedAllModelsReturnUrl();
    if (!returnTo || !returnTo.startsWith('/collections/all')) return;
    $$('.preorder-back-link[href*="/collections/all"]').forEach(link => {
      link.href = returnTo;
    });
    window.addEventListener('pageshow', event => {
      if (!event.persisted) return;
      location.replace(returnTo);
    });
  };
  restoreAllModelsReturnUrl();
  const preserveCollectionReturnLinks = (root = document) => {
    const collectionPage = $('.collection-page');
    if (!collectionPage) return;
    const path = location.pathname.replace(/\/$/, '');
    if (!path.startsWith('/collections/') || path === '/collections/all') return;
    const returnTo = `${location.pathname}${location.search}`;
    $$('[data-product-card] a.product-card-media, [data-product-card] a.product-card-title', root).forEach(link => {
      try {
        const url = new URL(link.href, location.origin);
        if (url.origin !== location.origin) return;
        url.searchParams.set('return_to', returnTo);
        link.href = url.toString();
      } catch (_) {}
    });
  };
  preserveCollectionReturnLinks();
  {
    const params = new URLSearchParams(location.search);
    const returnTo = params.get('return_to');
    if (returnTo && returnTo.startsWith('/collections/')) {
      $$('.preorder-back-link').forEach(link => {
        link.href = returnTo;
      });
    }
  }
  if ($('.all-models-page')) {
    const savedReturnTo = storedAllModelsReturnUrl();
    const pageIsPlainAllModels = location.pathname.replace(/\/$/, '') === '/collections/all' && !location.search;
    const cameFromProduct = /\/products\//.test(document.referrer || '');
    if (pageIsPlainAllModels && savedReturnTo && savedReturnTo !== currentAllModelsReturnUrl() && cameFromProduct) {
      location.replace(savedReturnTo);
      return;
    }
  }
  preserveAllModelsReturnLinks();
  document.addEventListener('click', event => {
    if (!$('.all-models-page')) return;
    const link = event.target.closest('[data-product-card] a.product-card-media, [data-product-card] a.product-card-title');
    if (!link) return;
    rememberAllModelsReturnUrl();
  }, true);
  if ($('.all-models-page')) {
    new URLSearchParams(location.search).getAll('kdc_filter').forEach(entry => {
      const [group, ...valueParts] = String(entry).split(':');
      const value = valueParts.join(':');
      $$('[data-source-url]').forEach(input => {
        if (input.dataset.filterGroup === group && input.value === value) input.checked = true;
      });
    });
  }

  const initializeAllModelsInfiniteScroll = () => {
    const infinitePage = $('.all-models-page');
    const infiniteGrid = $('.all-models-grid', infinitePage || document);
    const infinitePagination = $('.pagination', infinitePage || document);
    if (!infinitePage || !infiniteGrid || !infinitePagination) return;
    let nextUrl = $('a:last-child', infinitePagination)?.textContent.trim().toLowerCase() === 'next'
      ? $('a:last-child', infinitePagination).href
      : null;
    let loading = false;
    const status = document.createElement('div');
    status.className = 'infinite-scroll-status';
    status.innerHTML = '<span>Scroll for more models</span><button type="button" hidden>Try again</button>';
    infinitePagination.replaceWith(status);

    const loadNext = async () => {
      if (loading || !nextUrl) return;
      loading = true;
      status.classList.add('is-loading');
      status.querySelector('span').textContent = 'Loading more models…';
      status.querySelector('button').hidden = true;
      try {
        const response = await fetch(nextUrl, { headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('Unable to load products');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const newGrid = doc.querySelector('.all-models-grid');
        const newPagination = doc.querySelector('.all-models-page .pagination');
        if (!newGrid) throw new Error('Products were not found');
        const fragment = document.createDocumentFragment();
        [...newGrid.children].forEach(card => fragment.appendChild(card));
        infiniteGrid.appendChild(fragment);
        bindWishlistToggles(infiniteGrid);
        preserveAllModelsReturnLinks(infiniteGrid);
        preserveCollectionReturnLinks(infiniteGrid);
        const nextLink = newPagination && [...newPagination.querySelectorAll('a')]
          .find(link => link.textContent.trim().toLowerCase() === 'next');
        nextUrl = nextLink?.href || null;
        status.querySelector('span').textContent = nextUrl ? 'Scroll for more models' : 'All models loaded';
        if (!nextUrl) observer.disconnect();
      } catch (_) {
        status.querySelector('span').textContent = 'Couldn’t load more models';
        status.querySelector('button').hidden = false;
      } finally {
        loading = false;
        status.classList.remove('is-loading');
      }
    };
    status.querySelector('button').addEventListener('click', loadNext);
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) loadNext();
    }, { rootMargin: '700px 0px' });
    observer.observe(status);
  };
  initializeAllModelsInfiniteScroll();

  const initializePreorderLazyLoading = () => {
    const preorderPage = $('.preorder-collection-page');
    const preorderGrid = $('[data-preorder-lazy-grid]', preorderPage || document);
    const paginationHost = $('[data-preorder-lazy-pagination]', preorderPage || document);
    const preorderPagination = $('.pagination', paginationHost || document);
    if (!preorderPage || !preorderGrid || !paginationHost || !preorderPagination) return;
    let nextUrl = [...preorderPagination.querySelectorAll('a')]
      .find(link => link.textContent.trim().toLowerCase() === 'next')?.href || null;
    if (!nextUrl) {
      paginationHost.hidden = true;
      return;
    }
    const visibleCardCount = preorderGrid.children.length;
    const allCards = [...preorderGrid.children];
    let loading = false;
    let preparing = true;
    let pendingCards = [];
    const status = document.createElement('div');
    status.className = 'infinite-scroll-status preorder-lazy-status';
    status.innerHTML = '<span>Scroll for more pre-orders</span><button type="button" hidden>Try again</button>';
    paginationHost.replaceWith(status);

    const loadNext = () => {
      if (loading || preparing || !pendingCards.length) return;
      loading = true;
      status.classList.add('is-loading');
      status.querySelector('span').textContent = 'Loading...';
      status.querySelector('button').hidden = true;
      requestAnimationFrame(() => {
        const nextCards = pendingCards.splice(0, visibleCardCount);
        preorderGrid.append(...nextCards);
        bindWishlistToggles(preorderGrid);
        preserveCollectionReturnLinks(preorderGrid);
        status.querySelector('span').textContent = pendingCards.length ? 'Scroll for more pre-orders' : '~ End ~';
        if (!pendingCards.length) observer.disconnect();
        loading = false;
        status.classList.remove('is-loading');
      });
    };
    status.querySelector('button').addEventListener('click', () => {
      if (pendingCards.length) loadNext();
      else prepareGlobalOrder();
    });
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) loadNext();
    }, { rootMargin: '700px 0px' });
    observer.observe(status);

    const prepareGlobalOrder = async () => {
      status.classList.add('is-loading');
      status.querySelector('span').textContent = 'Loading...';
      status.querySelector('button').hidden = true;
      try {
        while (nextUrl) {
          const response = await fetch(nextUrl, { headers: { Accept: 'text/html' } });
          if (!response.ok) throw new Error('Unable to load pre-orders');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const newGrid = doc.querySelector('[data-preorder-lazy-grid]');
          const newPagination = doc.querySelector('[data-preorder-lazy-pagination] .pagination');
          if (!newGrid) throw new Error('Pre-order products were not found');
          allCards.push(...newGrid.children);
          nextUrl = newPagination && [...newPagination.querySelectorAll('a')]
            .find(link => link.textContent.trim().toLowerCase() === 'next')?.href || null;
        }
        const uniqueCards = [...new Map(allCards.map(card => [card.dataset.productHandle, card])).values()];
        uniqueCards.sort((a, b) => Number(b.dataset.productCreatedAt || 0) - Number(a.dataset.productCreatedAt || 0));
        preorderGrid.replaceChildren(...uniqueCards.slice(0, visibleCardCount));
        pendingCards = uniqueCards.slice(visibleCardCount);
        bindWishlistToggles(preorderGrid);
        preserveCollectionReturnLinks(preorderGrid);
        status.querySelector('span').textContent = pendingCards.length ? 'Scroll for more pre-orders' : '~ End ~';
        if (!pendingCards.length) observer.disconnect();
      } catch (_) {
        status.querySelector('span').textContent = 'Couldn’t load more pre-orders';
        status.querySelector('button').hidden = false;
      } finally {
        preparing = false;
        status.classList.remove('is-loading');
      }
    };
    prepareGlobalOrder();
  };
  initializePreorderLazyLoading();

  // Mobile product cards: touch-hover while the customer scrolls. This never
  // prevents the link click; it only reveals the animated quick-add overlay.
  let touchedProductCard = null;
  let touchedProductTimer = null;
  const revealTouchedCard = card => {
    if (touchedProductTimer) clearTimeout(touchedProductTimer);
    if (touchedProductCard && touchedProductCard !== card) touchedProductCard.classList.remove('is-touch-open');
    touchedProductCard = card;
    card?.classList.add('is-touch-open');
  };
  const softlyHideTouchedCard = () => {
    if (touchedProductTimer) clearTimeout(touchedProductTimer);
    touchedProductTimer = setTimeout(() => {
      touchedProductCard?.classList.remove('is-touch-open');
      touchedProductCard = null;
    }, 1400);
  };
  document.addEventListener('touchstart', event => {
    if (!window.matchMedia('(max-width: 700px) and (hover: none)').matches) return;
    const card = event.target.closest('.product-card');
    if (card) revealTouchedCard(card);
  }, { passive:true });
  document.addEventListener('touchend', softlyHideTouchedCard, { passive:true });
  document.addEventListener('touchcancel', softlyHideTouchedCard, { passive:true });

  // Submit All Models filters without navigating away from the page.
  const allModelsFilterForm = $('#CollectionFilters');
  allModelsFilterForm?.addEventListener('submit', async event => {
    if (!$('.all-models-page')) return;
    event.preventDefault();
    const applyButton = $('.filter-apply', allModelsFilterForm);
    const url = new URL(location.pathname, location.origin);
    new FormData(allModelsFilterForm).forEach((value, key) => {
      if (String(value).trim()) url.searchParams.append(key, value);
    });
    const selectedSources = $$('[data-source-url]:checked', allModelsFilterForm);
    selectedSources.forEach(input => url.searchParams.append('kdc_filter', `${input.dataset.filterGroup}:${input.value}`));
    applyButton?.classList.add('is-loading');
    if (applyButton) applyButton.textContent = 'Applying…';
    try {
      const current = $('.all-models-page .collection-products-column');
      let incoming;
      if (selectedSources.length) {
        const grouped = new Map();
        selectedSources.forEach(input => {
          const key = input.dataset.filterGroup || 'other';
          if (!grouped.has(key)) grouped.set(key, []);
          grouped.get(key).push(input.dataset.sourceUrl);
        });
        const sortBy = String(new FormData(allModelsFilterForm).get('sort_by') || '');
        const fetchCollection = async sourceUrl => {
          const cards = new Map();
          let pageUrl = new URL(sourceUrl, location.origin);
          if (sortBy) pageUrl.searchParams.set('sort_by', sortBy);
          for (let page = 0; page < 10 && pageUrl; page += 1) {
            const response = await fetch(pageUrl, { headers:{Accept:'text/html'} });
            if (!response.ok) throw new Error('Unable to load a selected filter');
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            doc.querySelectorAll('.product-card[data-product-handle]').forEach(card => {
              cards.set(card.dataset.productHandle, card);
            });
            const next = [...doc.querySelectorAll('.pagination a')]
              .find(link => link.textContent.trim().toLowerCase() === 'next');
            pageUrl = next ? new URL(next.href, location.origin) : null;
          }
          return cards;
        };
        const groupMaps = [];
        for (const urls of grouped.values()) {
          const maps = await Promise.all(urls.map(fetchCollection));
          const union = new Map();
          maps.forEach(map => map.forEach((card, handle) => union.set(handle, card)));
          groupMaps.push(union);
        }
        let matches = new Map(groupMaps[0] || []);
        groupMaps.slice(1).forEach(group => {
          matches = new Map([...matches].filter(([handle]) => group.has(handle)));
        });
        const priceInputs = $$('input[type="number"]', allModelsFilterForm);
        const minPrice = Number(priceInputs[0]?.value || 0);
        const maxPrice = Number(priceInputs[1]?.value || Infinity);
        let cards = [...matches.values()].filter(card => {
          const price = Number(card.dataset.price || 0);
          return price >= minPrice && price <= maxPrice;
        });
        if (sortBy.includes('price-ascending')) cards.sort((a,b) => Number(a.dataset.price)-Number(b.dataset.price));
        else if (sortBy.includes('price-descending')) cards.sort((a,b) => Number(b.dataset.price)-Number(a.dataset.price));
        else if (sortBy.includes('title-descending')) cards.sort((a,b) => b.dataset.title.localeCompare(a.dataset.title));
        else if (sortBy.includes('title-ascending')) cards.sort((a,b) => a.dataset.title.localeCompare(b.dataset.title));
        incoming = document.createElement('div');
        incoming.className = 'collection-products-column';
        if (cards.length) {
          const grid = document.createElement('div');
          grid.className = 'product-grid all-models-grid';
          cards.forEach(card => grid.appendChild(card));
          incoming.appendChild(grid);
        } else {
          incoming.innerHTML = '<div class="empty-state"><h2>No models found</h2><p>Try removing one filter or selecting another combination.</p></div>';
        }
        const count = $('.new-collection-title-row p');
        if (count) count.textContent = `${cards.length} products`;
      } else {
        url.searchParams.delete('kdc_filter');
        const response = await fetch(url, { headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('Unable to apply filters');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        incoming = doc.querySelector('.all-models-page .collection-products-column');
      }
      if (!incoming || !current) throw new Error('Filtered products were not found');
      current.replaceWith(incoming);
      history.replaceState({}, '', url);
      bindWishlistToggles(incoming);
      preserveAllModelsReturnLinks(incoming);
      initializeAllModelsInfiniteScroll();
      document.getElementById('AllModelsFilterSidebar')?.classList.remove('mobile-is-open');
      $('[data-all-models-layout]')?.classList.remove('mobile-filters-open');
      document.documentElement.classList.remove('overflow-hidden');
      incoming.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } catch (_) {
      if (applyButton) applyButton.textContent = 'Try Again';
      return;
    } finally {
      applyButton?.classList.remove('is-loading');
      if (applyButton && applyButton.textContent !== 'Try Again') applyButton.textContent = 'Apply Filters';
    }
  });

  // Keep legacy pre-order URLs stable even when Shopify removes an unused tag
  // and redirects the customer back to the unfiltered All Models collection.
  if (location.pathname.replace(/\/$/, '') === '/collections/all/preorder' ||
      location.pathname.replace(/\/$/, '') === '/collections/all/pre-order' ||
      location.pathname.replace(/\/$/, '') === '/collections/pre-orders') {
    location.replace('/search?view=preorder&type=product&q=tag%3Apreorder&sort_by=created-descending');
  }
  if (location.pathname.replace(/\/$/, '') === '/rc') {
    location.replace('/collections/rc');
  }

  // Backward compatibility for links from the first converted package.
  if (document.body.classList.contains('template-404')) {
    const legacy = location.pathname.replace(/\/$/, '');
    const redirects = {
      '/pages/brands': '/collections',
      '/brands': '/collections',
      '/rc': '/collections/rc',
      '/collections/pre-orders': '/search?view=preorder&type=product&q=tag%3Apreorder&sort_by=created-descending',
      '/collections/new-arrivals': '/collections/all?sort_by=created-descending',
      '/collections/sale': '/collections/all/sale',
      '/pages/contact': '/#contact-details',
      '/pages/pre-order-policy': '/#preorder-steps',
      '/collections/all/pre-order': '/search?view=preorder&type=product&q=tag%3Apreorder&sort_by=created-descending',
      '/pages/wishlist': '/#wishlist',
    };
    if (redirects[legacy]) location.replace(redirects[legacy]);
    else if (legacy.startsWith('/brands/')) location.replace('/collections/' + legacy.slice('/brands/'.length) + '?view=brand');
  }

  if (location.hash === '#request-model') location.replace('/pages/request-model');
  if (location.hash === '#wishlist') { renderWishlist(); toggleLayer(wishlistModal, true); }

  // Predictive product search.
  const pInput = $('[data-predictive-input]'), pResults = $('[data-predictive-results]'), pForm = $('[data-preorder-search-form]');
  let timer;
  pInput?.addEventListener('input', () => { clearTimeout(timer); const q=pInput.value.trim(); if(q.length<2){pResults.innerHTML='';return;} timer=setTimeout(async()=>{ try { const r=await fetch(`/search/suggest.json?q=${encodeURIComponent(`tag:preorder ${q}`)}&resources[type]=product&resources[limit]=6`); const j=await r.json(); const items=j.resources?.results?.products||[]; pResults.innerHTML=items.map(p=>`<a class="predictive-item" href="${p.url}">${p.image ? `<img src="${p.image}" alt="">` : ''}<span><strong>${escapeHtml(p.title)}</strong><small>${escapeHtml(p.vendor||'')}</small></span><b>${p.price || ''}</b></a>`).join('') || '<p class="predictive-empty">No matching pre-order models.</p>'; } catch(_){} },250); });
  pForm?.addEventListener('submit', event => { const q=pInput?.value.trim(); if(!q) return; event.preventDefault(); location.assign(`/search?view=preorder&type=product&q=${encodeURIComponent(`tag:preorder ${q}`)}&sort_by=created-descending`); });

  // Collection filter drawer.
  const filter = $('[data-filter-sidebar]');
  $('[data-filter-toggle]')?.addEventListener('click',()=>filter?.classList.add('is-open'));
  $('[data-filter-close]')?.addEventListener('click',()=>filter?.classList.remove('is-open'));


  function initHomeProductChips() {
    const homeChipGroup = $('[data-home-chip-group]');
    if (!homeChipGroup) return;
    const empty = $('[data-home-filter-empty]');
    const applyHomeChip = (key) => {
      const cards = $$('[data-product-card]', $('[data-home-product-grid]') || document);
      let visible = 0;
      cards.forEach(card => {
        const price = Number(card.dataset.price || 0);
        const hay = `${card.dataset.tags || ''} ${card.dataset.scale || ''} ${card.dataset.title || ''}`.toLowerCase();
        let show = key === 'all';
        if (key === 'under-999') show = price < 1000;
        else if (key === '1000-1999') show = price >= 1000 && price < 2000;
        else if (key === '2000-2999') show = price >= 2000 && price < 3000;
        else if (key === '3000+') show = price >= 3000;
        else if (key.startsWith('1/')) show = hay.includes(key.toLowerCase());
        card.hidden = !show;
        if (show) visible++;
      });
      if (empty) empty.hidden = visible !== 0;
      $$('[data-home-chip]', homeChipGroup).forEach(b => b.classList.toggle('active', b.dataset.homeChip === key));
    };
    $$('[data-home-chip]', homeChipGroup).forEach(b => {
      if (b.dataset.homeChipBound === 'true') return;
      b.dataset.homeChipBound = 'true';
      b.addEventListener('click', () => applyHomeChip(b.dataset.homeChip || 'all'));
    });
    const activeChip = $('[data-home-chip].active', homeChipGroup);
    applyHomeChip(activeChip?.dataset.homeChip || 'all');
  }
  initHomeProductChips();

  // Lazy-load recommendation section content.
  $$('[data-product-recommendations]').forEach(async section => {
    if (section.innerHTML.trim()) return;
    try { const html=await fetch(section.dataset.url).then(r=>r.text()); const doc=new DOMParser().parseFromString(html,'text/html'); const replacement=doc.querySelector('[data-product-recommendations]'); if(replacement) section.innerHTML=replacement.innerHTML; } catch(_){}
  });

  // Live Google Reviews via the Maps JavaScript Places library.
  let googleMapsLoaderPromise;
  function loadGoogleMapsPlaces(apiKey) {
    if (window.google?.maps?.importLibrary) return Promise.resolve();
    if (googleMapsLoaderPromise) return googleMapsLoaderPromise;
    googleMapsLoaderPromise = new Promise((resolve, reject) => {
      const callback = `kdcGoogleMapsReady_${Date.now()}`;
      const script = document.createElement('script');
      const params = new URLSearchParams({ key: apiKey, libraries: 'places', v: 'weekly', callback, loading: 'async', auth_referrer_policy: 'origin' });
      window[callback] = () => { delete window[callback]; resolve(); };
      script.src = `https://maps.googleapis.com/maps/api/js?${params.toString()}`;
      script.async = true;
      script.onerror = () => { delete window[callback]; reject(new Error('Google Maps JavaScript API failed to load.')); };
      document.head.appendChild(script);
    });
    return googleMapsLoaderPromise;
  }

  function googleStars(rating) {
    const rounded = Math.max(0, Math.min(5, Math.round(Number(rating || 0))));
    return '★'.repeat(rounded) + '☆'.repeat(5 - rounded);
  }

  function reviewInitial(name) {
    const clean = String(name || '').trim();
    return clean ? clean.charAt(0).toUpperCase() : 'G';
  }

  async function initGoogleReviewSection(section) {
    if (!section || section.dataset.googleReviewsReady === 'true') return;
    section.dataset.googleReviewsReady = 'true';
    const apiKey = String(section.dataset.googleApiKey || '').trim();
    const placeId = String(section.dataset.googlePlaceId || '').trim();
    const error = $('[data-google-review-error]', section);
    const track = $('[data-google-review-track]', section);

    if (!apiKey || !placeId) {
      const designMode = Boolean(window.Shopify?.designMode);
      if (designMode && error) {
        error.hidden = false;
        error.textContent = !apiKey ? 'Add your Google Maps JavaScript API key in this Home section to load live reviews.' : 'Add the Google Place ID to load live reviews.';
      } else {
        section.hidden = true;
      }
      return;
    }

    try {
      await loadGoogleMapsPlaces(apiKey);
      const { Place } = await google.maps.importLibrary('places');
      const place = new Place({ id: placeId, requestedLanguage: 'en', requestedRegion: 'IN' });
      await place.fetchFields({ fields: ['displayName', 'rating', 'userRatingCount', 'reviews', 'googleMapsLinks', 'googleMapsURI'] });

      const placeName = $('[data-google-place-name]', section);
      const ratingEl = $('[data-google-rating]', section);
      const countEl = $('[data-google-review-count]', section);
      const summaryStars = $('[data-google-summary-stars]', section);
      const reviewsLink = $('[data-google-reviews-link]', section);
      const writeReview = $('[data-google-write-review]', section);

      if (placeName) placeName.textContent = place.displayName || 'Kerala Diecast Cars';
      if (ratingEl) ratingEl.textContent = Number(place.rating || 0).toFixed(1);
      if (countEl) countEl.textContent = String(place.userRatingCount || 0);
      if (summaryStars) {
        summaryStars.textContent = googleStars(place.rating);
        summaryStars.setAttribute('aria-label', `${Number(place.rating || 0).toFixed(1)} out of 5 stars`);
      }

      const reviewListUrl = place.googleMapsLinks?.reviewsURI || place.googleMapsURI || '#';
      const writeReviewUrl = place.googleMapsLinks?.writeAReviewURI || reviewListUrl;
      if (reviewsLink) reviewsLink.href = reviewListUrl;
      if (writeReview) writeReview.href = writeReviewUrl;

      const reviews = Array.isArray(place.reviews) ? place.reviews.slice(0, 5) : [];
      if (!reviews.length) {
        track.innerHTML = '<div class="google-review-loading">No Google reviews are available yet.</div>';
        return;
      }

      track.innerHTML = '';
      reviews.forEach(review => {
        const author = review.authorAttribution || {};
        const card = document.createElement('article');
        card.className = 'google-review-card';

        const authorRow = document.createElement('div');
        authorRow.className = 'google-review-author';

        if (author.photoURI) {
          const img = document.createElement('img');
          img.className = 'google-review-avatar';
          img.src = author.photoURI;
          img.alt = '';
          img.loading = 'lazy';
          authorRow.appendChild(img);
        } else {
          const fallback = document.createElement('span');
          fallback.className = 'google-review-avatar-fallback';
          fallback.textContent = reviewInitial(author.displayName);
          authorRow.appendChild(fallback);
        }

        const authorCopy = document.createElement('div');
        authorCopy.className = 'google-review-author-copy';
        const authorName = document.createElement(author.uri ? 'a' : 'span');
        authorName.className = 'google-review-author-name';
        authorName.textContent = author.displayName || 'Google reviewer';
        if (author.uri) { authorName.href = author.uri; authorName.target = '_blank'; authorName.rel = 'noopener'; }
        const when = document.createElement('span');
        when.className = 'google-review-time';
        when.textContent = review.relativePublishTimeDescription || '';
        authorCopy.append(authorName, when);
        authorRow.appendChild(authorCopy);

        const g = document.createElement('span');
        g.className = 'google-review-gmark';
        g.textContent = 'G';
        g.setAttribute('aria-label', 'Google');
        authorRow.appendChild(g);

        const stars = document.createElement('div');
        stars.className = 'google-review-card-stars';
        stars.textContent = googleStars(review.rating);
        stars.setAttribute('aria-label', `${Number(review.rating || 0).toFixed(0)} out of 5 stars`);

        const text = document.createElement('p');
        text.className = 'google-review-text';
        text.textContent = review.text || review.originalText || 'Rated on Google.';

        card.append(authorRow, stars, text);
        if (review.googleMapsURI) {
          const link = document.createElement('a');
          link.className = 'google-review-card-link';
          link.href = review.googleMapsURI;
          link.target = '_blank';
          link.rel = 'noopener';
          link.textContent = 'View on Google';
          card.appendChild(link);
        }
        track.appendChild(card);
      });

      const viewport = $('[data-google-review-viewport]', section);
      const prev = $('[data-google-review-prev]', section);
      const next = $('[data-google-review-next]', section);
      const dots = $('[data-google-review-dots]', section);
      if (dots) {
        dots.innerHTML = '';
        reviews.forEach((_, index) => {
          const dot = document.createElement('span');
          dot.className = `google-review-dot${index === 0 ? ' is-active' : ''}`;
          dots.appendChild(dot);
        });
      }

      const cards = $$('.google-review-card', track);
      const dotEls = dots ? $$('.google-review-dot', dots) : [];
      const currentIndex = () => {
        if (!viewport || !cards.length) return 0;
        const left = viewport.scrollLeft;
        let best = 0;
        let dist = Infinity;
        cards.forEach((card, index) => { const d = Math.abs(card.offsetLeft - left); if (d < dist) { dist = d; best = index; } });
        return best;
      };
      const syncDots = () => {
        const idx = currentIndex();
        dotEls.forEach((dot, index) => dot.classList.toggle('is-active', index === idx));
        if (prev) prev.disabled = idx <= 0;
        if (next) next.disabled = idx >= cards.length - 1;
      };
      const go = direction => {
        if (!viewport || !cards.length) return;
        const idx = Math.max(0, Math.min(cards.length - 1, currentIndex() + direction));
        viewport.scrollTo({ left: cards[idx].offsetLeft, behavior: 'smooth' });
        setTimeout(syncDots, 380);
      };
      prev?.addEventListener('click', () => go(-1));
      next?.addEventListener('click', () => go(1));
      viewport?.addEventListener('scroll', () => requestAnimationFrame(syncDots), { passive: true });
      syncDots();
    } catch (err) {
      console.warn('Kerala Diecast Cars Google Reviews:', err);
      if (window.Shopify?.designMode && error) {
        error.hidden = false;
        error.textContent = 'Google Reviews could not load. Check the API key restrictions, billing, enabled APIs, and Place ID.';
      } else {
        section.hidden = true;
      }
    }
  }


  async function initGooglePlacePhotos(section) {
    if (!section || section.dataset.googlePlacePhotosReady === 'true') return;
    section.dataset.googlePlacePhotosReady = 'true';

    const apiKey = String(section.dataset.googleApiKey || '').trim();
    const placeId = String(section.dataset.googlePlaceId || '').trim();
    const mapsUrl = String(section.dataset.googleMapsUrl || '').trim();
    const grid = $('[data-google-place-photo-grid]', section);
    const error = $('[data-google-place-photo-error]', section);
    if (!grid) return;

    if (!apiKey || !placeId) {
      if (!grid.querySelector('img')) {
        grid.innerHTML = '<div class="google-place-photo-loading">Add your Google Maps API key in the Home section to load store photos.</div>';
      }
      if (window.Shopify?.designMode && error) {
        error.hidden = false;
        error.textContent = !apiKey ? 'Add the Google Maps JavaScript API key to load place photos.' : 'Add the Google Place ID to load place photos.';
      }
      return;
    }

    try {
      await loadGoogleMapsPlaces(apiKey);
      const { Place } = await google.maps.importLibrary('places');
      const place = new Place({ id: placeId, requestedLanguage: 'en', requestedRegion: 'IN' });
      await place.fetchFields({ fields: ['displayName', 'photos', 'googleMapsURI'] });
      const photos = Array.isArray(place.photos) ? place.photos.slice(0, 4) : [];
      if (!photos.length) {
        if (!grid.querySelector('img')) grid.innerHTML = '<div class="google-place-photo-loading">No Google Maps photos are available yet.</div>';
        return;
      }

      grid.innerHTML = '';
      grid.classList.remove('is-single', 'is-two', 'is-three');
      if (photos.length === 1) grid.classList.add('is-single');
      if (photos.length === 2) grid.classList.add('is-two');
      if (photos.length === 3) grid.classList.add('is-three');

      photos.forEach(photo => {
        const item = document.createElement('figure');
        item.className = 'google-place-photo';
        item.style.margin = '0';

        const link = document.createElement('a');
        link.className = 'google-place-photo-link';
        link.href = photo.googleMapsURI || place.googleMapsURI || mapsUrl || '#';
        link.target = '_blank';
        link.rel = 'noopener';
        link.setAttribute('aria-label', `View ${place.displayName || 'Kerala Diecast Cars'} photo on Google Maps`);

        const img = document.createElement('img');
        img.src = photo.getURI({ maxWidth: 1000, maxHeight: 850 });
        img.alt = `${place.displayName || 'Kerala Diecast Cars'} on Google Maps`;
        img.loading = 'lazy';
        link.appendChild(img);
        item.appendChild(link);

        const attributions = Array.isArray(photo.authorAttributions) ? photo.authorAttributions : [];
        if (attributions.length) {
          const attribution = document.createElement('figcaption');
          attribution.className = 'google-place-photo-attribution';
          attribution.append('Photo by ');
          attributions.forEach((author, index) => {
            if (index) attribution.append(', ');
            if (author.uri) {
              const a = document.createElement('a');
              a.href = author.uri;
              a.target = '_blank';
              a.rel = 'noopener';
              a.textContent = author.displayName || 'Google Maps user';
              attribution.appendChild(a);
            } else {
              attribution.append(author.displayName || 'Google Maps user');
            }
          });
          item.appendChild(attribution);
        }
        grid.appendChild(item);
      });
    } catch (err) {
      console.warn('Kerala Diecast Cars Google Photos:', err);
      if (!grid.querySelector('img')) grid.innerHTML = '<div class="google-place-photo-loading">Google Maps photos could not load.</div>';
      if (window.Shopify?.designMode && error) {
        error.hidden = false;
        error.textContent = 'Google Maps photos could not load. Check the API key restrictions, billing, enabled APIs, and Place ID.';
      }
    }
  }

  $$('[data-google-place-photos]').forEach(section => {
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          observer.disconnect();
          initGooglePlacePhotos(section);
        }
      }, { rootMargin: '300px 0px' });
      observer.observe(section);
    } else {
      initGooglePlacePhotos(section);
    }
  });

  function initFeaturedAutoScroll(root = document) {
    $$('[data-featured-autoscroll]', root).forEach(section => {
      if (section.dataset.autoscrollReady === 'true') return;
      const viewport = $('[data-featured-autoscroll-viewport]', section);
      const track = $('[data-featured-autoscroll-track]', section);
      const originalSet = $('[data-featured-autoscroll-set]', section);
      if (!viewport || !track || !originalSet) return;
      const slides = Array.from(originalSet.children);
      if (slides.length < 2) return;

      section.dataset.autoscrollReady = 'true';
      const appendLoopSet = () => {
        const clone = originalSet.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(el => el.setAttribute('tabindex', '-1'));
        track.appendChild(clone);
      };

      let paused = false;
      let dragging = false;
      let startX = 0;
      let startScroll = 0;
      let lastTime = performance.now();
      let cycleWidth = 0;
      const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

      const measure = () => {
        const styles = getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        cycleWidth = originalSet.getBoundingClientRect().width + gap;
        if (cycleWidth) {
          // Keep at least one complete repeated cycle beyond the visible area.
          // This is essential when only a few Featured Drops exist on a wide
          // desktop viewport.
          const requiredSets = Math.max(2, Math.ceil(viewport.clientWidth / cycleWidth) + 2);
          while (track.children.length < requiredSets) appendLoopSet();
        }
        if (cycleWidth && viewport.scrollLeft >= cycleWidth) viewport.scrollLeft %= cycleWidth;
      };
      measure();
      window.addEventListener('resize', measure, {passive:true});
      let loopResetFrame = 0;
      viewport.addEventListener('scroll', () => {
        if (!cycleWidth || viewport.scrollLeft < cycleWidth) return;
        cancelAnimationFrame(loopResetFrame);
        loopResetFrame = requestAnimationFrame(() => {
          if (viewport.scrollLeft >= cycleWidth) viewport.scrollLeft %= cycleWidth;
        });
      }, {passive:true});

      const tick = now => {
        const dt = Math.min(40, now - lastTime);
        lastTime = now;
        if (!paused && !dragging && !reducedMotion && cycleWidth > 0) {
          // Equivalent feel to Splide AutoScroll speed: 1.
          viewport.scrollLeft += Math.max(.35, dt / 16.667);
          if (viewport.scrollLeft >= cycleWidth) viewport.scrollLeft -= cycleWidth;
        }
        requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);

      let pointerActive = false;
      let draggedRecently = false;
      viewport.addEventListener('pointerdown', event => {
        if (event.pointerType === 'touch') return; // keep native touch scrolling/clicks.
        pointerActive = true;
        dragging = false;
        draggedRecently = false;
        paused = true;
        startX = event.clientX;
        startScroll = viewport.scrollLeft;
      });
      viewport.addEventListener('pointermove', event => {
        if (!pointerActive || event.pointerType === 'touch') return;
        const deltaX = event.clientX - startX;
        if (!dragging && Math.abs(deltaX) > 6) {
          dragging = true;
          draggedRecently = true;
          viewport.classList.add('is-dragging');
          viewport.setPointerCapture?.(event.pointerId);
        }
        if (!dragging) return;
        viewport.scrollLeft = startScroll - deltaX;
        if (cycleWidth > 0 && viewport.scrollLeft >= cycleWidth) viewport.scrollLeft %= cycleWidth;
      });
      const stopDrag = event => {
        pointerActive = false;
        if (dragging) {
          dragging = false;
          viewport.classList.remove('is-dragging');
          viewport.releasePointerCapture?.(event.pointerId);
          setTimeout(() => { draggedRecently = false; }, 120);
        }
        setTimeout(() => { paused = false; }, 450);
      };
      viewport.addEventListener('pointerup', stopDrag);
      viewport.addEventListener('pointercancel', stopDrag);
      viewport.addEventListener('mouseenter', () => { if (!dragging) paused = true; });
      viewport.addEventListener('mouseleave', () => { if (!dragging) paused = false; });
      viewport.addEventListener('focusin', () => { paused = true; });
      viewport.addEventListener('focusout', () => { paused = false; });
      viewport.addEventListener('touchstart', () => { paused = true; }, {passive:true});
      viewport.addEventListener('touchend', () => setTimeout(() => { paused = false; }, 650), {passive:true});

      // Make every Featured Drop card clickable, including the cloned loop set.
      // A small pointer movement is treated as a click; a real drag never navigates.
      viewport.addEventListener('click', event => {
        if (draggedRecently || dragging) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        const slide = event.target.closest('.featured-autoscroll-slide[data-featured-product-url]');
        if (!slide || !viewport.contains(slide)) return;
        // Native anchors/buttons keep their own behavior. The rest of the card
        // navigates to the same product URL.
        if (event.target.closest('a,button,input,select,textarea')) return;
        const url = slide.dataset.featuredProductUrl;
        if (url) window.location.assign(url);
      });
    });
  }

  async function initFeaturedHomeProducts() {
    const host = $('[data-featured-home-products]');
    if (!host) return;
    const url = host.dataset.featuredUrl;
    if (!url) return;
    try {
      const response = await fetch(url, {headers:{'X-Requested-With':'XMLHttpRequest'}});
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fragment = $('[data-featured-home-fragment]', doc);
      if (!fragment) throw new Error('Featured section fragment missing');
      if (!fragment.innerHTML.trim()) {
        host.hidden = true;
        return;
      }
      host.innerHTML = fragment.innerHTML;
      host.hidden = false;
      initFeaturedAutoScroll(host);
    } catch (error) {
      console.warn('Kerala Diecast Cars featured products:', error);
      host.hidden = true;
    }
  }

  initFeaturedHomeProducts();

  async function initNewArrivalsHomeProducts() {
    const host = $('[data-home-product-grid]');
    if (!host) return;
    const url = host.dataset.newArrivalsUrl;
    if (!url) return;
    const targetCount = 10;
    const maxPages = 8;
    try {
      const cards = [];
      const seen = new Set();
      let emptyNote = '';
      for (let page = 1; page <= maxPages && cards.length < targetCount; page += 1) {
        const pageUrl = new URL(url, window.location.origin);
        pageUrl.searchParams.set('page', String(page));
        const response = await fetch(pageUrl.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fragment = $('[data-new-arrivals-home-fragment]', doc);
        if (!fragment) throw new Error('New arrivals section fragment missing');
        const pageCards = $$('[data-product-card]', fragment);
        if (!pageCards.length) {
          if (!emptyNote) emptyNote = fragment.innerHTML.trim();
          break;
        }
        pageCards.forEach(card => {
          const key = card.querySelector('a[href*="/products/"]')?.getAttribute('href') || card.textContent.trim();
          if (cards.length < targetCount && key && !seen.has(key)) {
            seen.add(key);
            cards.push(card.outerHTML);
          }
        });
      }
      host.innerHTML = cards.length ? cards.join('') : emptyNote || '<p class="empty-note">No products found.</p>';
      host.removeAttribute('aria-busy');
      if (typeof bindWishlistToggles === 'function') bindWishlistToggles(host);
      initHomeProductChips();
      window.dispatchEvent(new CustomEvent('kdc:products-updated', { detail: { root: host } }));
    } catch (error) {
      console.warn('Kerala Diecast Cars new arrivals:', error);
      host.removeAttribute('aria-busy');
      host.innerHTML = '<p class="empty-note">No products found.</p>';
    }
  }

  initNewArrivalsHomeProducts();

  function initRcBannerCarousel(scope = document) {
    $$('[data-rc-banner-carousel]', scope).forEach(carousel => {
      if (carousel.dataset.rcBannerBound === 'true') return;
      carousel.dataset.rcBannerBound = 'true';
      const slides = $$('[data-rc-banner-slide]', carousel);
      const dots = $$('[data-rc-banner-dot]', carousel);
      if (slides.length < 2) return;
      let current = 0;
      let timer;
      const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
      const show = (index) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.tabIndex = active ? 0 : -1;
        });
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      };
      const stop = () => { if (timer) { window.clearInterval(timer); timer = undefined; } };
      const start = () => { if (!reduceMotion && !timer) timer = window.setInterval(() => show(current + 1), 4000); };
      $('[data-rc-banner-previous]', carousel)?.addEventListener('click', () => { show(current - 1); stop(); });
      $('[data-rc-banner-next]', carousel)?.addEventListener('click', () => { show(current + 1); stop(); });
      dots.forEach((dot, index) => dot.addEventListener('click', () => { show(index); stop(); }));
      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', start);
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', () => window.setTimeout(start, 0));
      show(0);
      start();
    });
  }

  async function initRcHomeProducts() {
    const host = $('[data-rc-home-products]');
    const bannerHost = $('[data-rc-home-banner]');
    if (!host) return;
    const url = host.dataset.rcUrl;
    if (!url) return;
    try {
      const response = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fragment = $('[data-rc-home-fragment]', doc);
      const bannerFragment = $('[data-rc-banner-fragment]', doc);
      if (!fragment) throw new Error('RC section fragment missing');
      if (bannerHost) {
        bannerHost.innerHTML = bannerFragment?.innerHTML || '';
        bannerHost.hidden = !bannerHost.innerHTML.trim();
        bannerHost.removeAttribute('aria-busy');
        initRcBannerCarousel(bannerHost);
      }
      host.innerHTML = fragment.innerHTML;
      seedInventoryMap(host);
      // The product cards are fetched after initial page setup, so their
      // wishlist controls need the same click bindings as regular cards.
      if (typeof bindWishlistToggles === 'function') bindWishlistToggles(host);
      if (typeof renderWishlist === 'function') renderWishlist();
    } catch (error) {
      console.warn('Kerala Diecast Cars RC home products:', error);
      if (bannerHost) bannerHost.hidden = true;
      host.innerHTML = '<p class="empty-note rc-home-empty">RC cars will be added here soon.</p>';
    }
  }

  initRcHomeProducts();

  async function initPreorderHomeProducts() {
    const host = $('[data-preorder-home-products]');
    if (!host) return;
    const url = host.dataset.preorderUrl;
    if (!url) return;
    try {
      const cards = [];
      let nextUrl = url;
      let pageCount = 0;
      while (nextUrl && pageCount < 10) {
        const response = await fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const sortedGrid = $('.preorder-product-grid', doc);
        const fragment = $('[data-preorder-home-fragment]', doc);
        const source = sortedGrid || fragment;
        if (!source) throw new Error('Pre-order section cards missing');
        cards.push(...$$('[data-product-card]', source));
        const pagination = $('[data-preorder-lazy-pagination] .pagination', doc);
        const nextLink = pagination && [...pagination.querySelectorAll('a')]
          .find(link => link.textContent.trim().toLowerCase() === 'next');
        nextUrl = nextLink?.href || null;
        if (nextUrl) {
          const nextPageUrl = new URL(nextUrl, location.origin);
          nextPageUrl.searchParams.set('section_id', 'main-preorder-search');
          nextUrl = nextPageUrl.toString();
        }
        pageCount += 1;
      }
      const newestCards = [...new Map(cards.map(card => [card.dataset.productHandle, card])).values()]
        .sort((a, b) => Number(b.dataset.productCreatedAt || 0) - Number(a.dataset.productCreatedAt || 0))
        .slice(0, 10);
      if (!newestCards.length) throw new Error('Pre-order section cards missing');
      host.replaceChildren(...newestCards);
      // Re-bind wishlist buttons that arrived through Section Rendering.
      if (typeof bindWishlistToggles === 'function') bindWishlistToggles(host);
      if (typeof renderWishlist === 'function') renderWishlist();
    } catch (error) {
      console.warn('Kerala Diecast Cars pre-order home products:', error);
      host.innerHTML = '<p class="empty-note preorder-home-empty">Currently, no pre-order items are available. More will be added soon.</p>';
    }
  }

  initPreorderHomeProducts();

  $$('[data-google-reviews]').forEach(section => {
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); initGoogleReviewSection(section); }
      }, { rootMargin: '500px 0px' });
      observer.observe(section);
    } else {
      initGoogleReviewSection(section);
    }
  });

  function escapeHtml(v='') { return String(v).replace(/[&<>'"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c])); }
})();

// Keep the Shopify Forms success card centered without moving the normal form.
(() => {
  const wrap = document.querySelector('.request-model-form-wrap');
  const appForm = wrap?.querySelector('.request-model-app-form');
  if (!wrap || !appForm) return;

  const deepText = root => {
    let text = root.textContent || '';
    root.querySelectorAll?.('*').forEach(element => {
      if (element.shadowRoot) text += ` ${deepText(element.shadowRoot)}`;
    });
    return text.replace(/\s+/g, ' ').trim();
  };

  const syncSuccessPosition = () => {
    const text = deepText(appForm);
    const isSuccess = /received your model request/i.test(text) || (/\bsuccess\b/i.test(text) && /thank you/i.test(text));
    wrap.classList.toggle('is-success-state', isSuccess);
  };

  const watchedRoots = new WeakSet();
  const observerOptions = { childList: true, subtree: true, characterData: true, attributes: true };
  let successObserver;
  const watchRoot = root => {
    if (!watchedRoots.has(root)) {
      successObserver.observe(root, observerOptions);
      watchedRoots.add(root);
    }
    root.querySelectorAll?.('*').forEach(element => {
      if (element.shadowRoot) watchRoot(element.shadowRoot);
    });
  };
  successObserver = new MutationObserver(() => {
    watchRoot(appForm);
    syncSuccessPosition();
  });
  watchRoot(appForm);
  window.setInterval(() => watchRoot(appForm), 1000);
  syncSuccessPosition();
})();

// Hide the Shopify Forms marketing disclaimer on the Request Model page only.
(() => {
  const appForm = document.querySelector('.request-model-app-form');
  if (!appForm) return;

  const disclaimerStart = 'by signing up, you agree to receive marketing emails and whatsapp messages';
  const watchedRoots = new WeakSet();
  const normalize = value => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const hideDisclaimer = root => {
    const elements = [...root.querySelectorAll?.('*') || []];
    const candidate = elements.find(element => {
      if (!normalize(element.textContent).includes(disclaimerStart)) return false;
      return ![...element.children].some(child => normalize(child.textContent).includes(disclaimerStart));
    });
    if (candidate) {
      candidate.hidden = true;
      candidate.style.setProperty('display', 'none', 'important');
      candidate.setAttribute('aria-hidden', 'true');
    }

    elements.forEach(element => {
      if (element.shadowRoot) watchRoot(element.shadowRoot);
    });
  };

  const watchRoot = root => {
    if (!root || watchedRoots.has(root)) return;
    watchedRoots.add(root);
    hideDisclaimer(root);
    new MutationObserver(() => hideDisclaimer(root)).observe(root, { childList: true, subtree: true });
  };

  watchRoot(appForm);
})();

// Prefill Shopify Forms when a sold-out product sends a customer here.
(() => {
  const appForm = document.querySelector('.request-model-app-form');
  if (!appForm) return;

  const params = new URLSearchParams(location.search);
  const model = params.get('model')?.trim() || '';
  const brand = params.get('brand')?.trim() || '';
  const scale = params.get('scale')?.trim() || '';
  const imageUrl = params.get('image')?.trim() || '';
  if (!model && !brand && !scale && !imageUrl) return;

  const roots = () => {
    const found = [appForm];
    for (let index = 0; index < found.length; index += 1) {
      found[index].querySelectorAll?.('*').forEach(element => {
        if (element.shadowRoot && !found.includes(element.shadowRoot)) found.push(element.shadowRoot);
      });
    }
    return found;
  };

  const fieldDescription = input => {
    const labels = [...(input.labels || [])].map(label => label.textContent || '');
    const closestLabel = input.closest?.('label')?.textContent || '';
    return [input.name, input.id, input.placeholder, input.getAttribute('aria-label'), closestLabel, ...labels]
      .filter(Boolean)
      .join(' ')
      .replace(/\s+/g, ' ')
      .toLowerCase();
  };

  const inputs = () => roots().flatMap(root => [...root.querySelectorAll('input')]);
  const selects = () => roots().flatMap(root => [...root.querySelectorAll('select')]);
  const buttons = () => roots().flatMap(root => [...root.querySelectorAll('button')]);
  const options = () => roots().flatMap(root => [...root.querySelectorAll('[role="option"]')]);
  const findTextInput = pattern => inputs().find(input => {
    const type = (input.type || 'text').toLowerCase();
    return ['text', 'search', ''].includes(type) && pattern.test(fieldDescription(input));
  });

  const setTextValue = (input, value) => {
    if (!input || !value || input.dataset.kdcPrefilled === value) return false;
    const setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value')?.set;
    if (setter) setter.call(input, value);
    else input.value = value;
    input.dataset.kdcPrefilled = value;
    input.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
    input.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
    return true;
  };

  const normalizeScale = value => String(value || '')
    .toLowerCase()
    .replace(/\bscale\b/g, '')
    .replace(/\s+/g, '')
    .trim();

  const findScaleSelect = () => selects().find(select => {
    if (/\bscale\b/.test(fieldDescription(select))) return true;
    const optionValues = [...select.options].map(option => normalizeScale(option.textContent || option.value));
    return ['1/64', '1/43', '1/36', '1/32', '1/24', '1/18'].some(value => optionValues.includes(value));
  });
  const labelledText = element => {
    const root = element?.getRootNode?.();
    return (element?.getAttribute('aria-labelledby') || '')
      .split(/\s+/)
      .filter(Boolean)
      .map(id => root?.getElementById?.(id)?.textContent || '')
      .join(' ');
  };
  const findScaleToggle = () => buttons().find(button =>
    /\bscale\b/.test(`${button.getAttribute('aria-label') || ''} ${labelledText(button)}`.toLowerCase())
  );
  const setScaleValue = (select, value) => {
    if (!select || !value || select.dataset.kdcPrefilled === value) return false;
    const wanted = normalizeScale(value);
    const option = [...select.options].find(item =>
      normalizeScale(item.value) === wanted || normalizeScale(item.textContent) === wanted
    );
    if (!option) return false;
    const setter = Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, 'value')?.set;
    if (setter) setter.call(select, option.value);
    else select.value = option.value;
    select.dataset.kdcPrefilled = value;
    select.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
    select.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
    return true;
  };

  let scaleChoosing = false;
  let scaleFilled = false;
  const chooseCustomScale = async value => {
    if (!value || scaleChoosing || scaleFilled) return;
    const wanted = normalizeScale(value);
    let toggle = findScaleToggle();
    if (!toggle) return;
    if (normalizeScale(toggle.textContent) === wanted) {
      scaleFilled = true;
      return;
    }

    scaleChoosing = true;
    try {
      if (toggle.getAttribute('aria-expanded') !== 'true') toggle.click();
      let choice;
      for (let attempt = 0; attempt < 12 && !choice; attempt += 1) {
        await new Promise(resolve => window.setTimeout(resolve, 30));
        choice = options().find(option => normalizeScale(option.textContent) === wanted);
      }
      choice?.click();
      await new Promise(resolve => window.requestAnimationFrame(resolve));
      toggle = findScaleToggle();
      scaleFilled = normalizeScale(toggle?.textContent) === wanted;
    } finally {
      scaleChoosing = false;
    }
  };

  let imageLoading = false;
  let imageFilled = false;
  const setImageFile = async input => {
    if (!input || !imageUrl || imageLoading || imageFilled) return;
    imageLoading = true;
    try {
      const response = await fetch(new URL(imageUrl, location.origin).href);
      if (!response.ok) throw new Error('Unable to load product image');
      const blob = await response.blob();
      const extension = blob.type.split('/')[1]?.replace('jpeg', 'jpg') || 'jpg';
      const safeName = (model || 'requested-model').replace(/[^a-z0-9]+/gi, '-').replace(/^-|-$/g, '').toLowerCase();
      const transfer = new DataTransfer();
      transfer.items.add(new File([blob], `${safeName || 'requested-model'}.${extension}`, { type: blob.type || 'image/jpeg' }));
      input.files = transfer.files;
      input.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
      input.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
      imageFilled = input.files?.length > 0;
    } catch (_) {
      imageFilled = false;
    } finally {
      imageLoading = false;
    }
  };

  const prefill = () => {
    setTextValue(findTextInput(/model\s*name/), model);
    setTextValue(findTextInput(/manufacturer\s*brand|brand\s*\/\s*manufacturer/), brand);
    const nativeScale = findScaleSelect();
    if (nativeScale) scaleFilled = setScaleValue(nativeScale, scale) || nativeScale.dataset.kdcPrefilled === scale;
    else chooseCustomScale(scale);
    setImageFile(inputs().find(input => input.type === 'file'));
  };

  const observer = new MutationObserver(prefill);
  observer.observe(appForm, { childList: true, subtree: true });
  let attempts = 0;
  const timer = window.setInterval(() => {
    prefill();
    attempts += 1;
    if (attempts >= 80 || (findTextInput(/model\s*name/)?.dataset.kdcPrefilled && findTextInput(/manufacturer\s*brand|brand\s*\/\s*manufacturer/)?.dataset.kdcPrefilled && (!scale || scaleFilled) && (!imageUrl || imageFilled))) {
      window.clearInterval(timer);
      observer.disconnect();
    }
  }, 150);
  prefill();
})();

/* v3.6.16 — All Models desktop filter drawer */
(() => {
  const layout = document.querySelector('[data-all-models-layout]');
  const toggle = document.querySelector('[data-desktop-filter-toggle]');
  const sidebar = document.getElementById('AllModelsFilterSidebar');
  if (!layout || !toggle || !sidebar) return;

  const setOpen = (open) => {
    layout.classList.toggle('filters-open', open);
    toggle.setAttribute('aria-expanded', String(open));
    sidebar.setAttribute('aria-hidden', String(!open));
  };

  const hasActiveFilterState = () => {
    const params = new URLSearchParams(window.location.search);
    return [...params.keys()].some(key => key.startsWith('filter.') || key === 'kdc_filter' || key === 'q');
  };

  setOpen(hasActiveFilterState());
  toggle.addEventListener('click', () => setOpen(!layout.classList.contains('filters-open')));

  window.addEventListener('resize', () => {
    if (window.innerWidth <= 900) setOpen(false);
  }, { passive: true });

  const mobileOpen = document.querySelector('[data-mobile-all-models-filter-open]');
  const mobileClose = document.querySelectorAll('[data-mobile-all-models-filter-close]');
  const mobileAccordions = [...sidebar.querySelectorAll('.new-filter-accordion')];

  // On mobile, keep the filter sheet compact by allowing only one section to
  // be expanded at a time. Desktop accordions remain independent.
  mobileAccordions.forEach(accordion => {
    accordion.addEventListener('toggle', () => {
      if (window.innerWidth > 900 || !accordion.open) return;
      mobileAccordions.forEach(other => {
        if (other !== accordion) other.open = false;
      });
    });
  });

  const setMobileOpen = (open) => {
    sidebar.classList.toggle('mobile-is-open', open);
    layout.classList.toggle('mobile-filters-open', open);
    document.documentElement.classList.toggle('overflow-hidden', open);
    sidebar.setAttribute('aria-hidden', String(!open));
    mobileOpen?.setAttribute('aria-expanded', String(open));
    if (open) {
      sidebar.hidden = false;
      sidebar.scrollTop = 0;
      sidebar.style.display = 'block';
      sidebar.style.width = '100%';
      sidebar.style.maxWidth = 'none';
      sidebar.style.visibility = 'visible';
      sidebar.style.opacity = '1';
      sidebar.style.pointerEvents = 'auto';
      sidebar.style.transform = 'translate3d(0,0,0)';
    } else {
      sidebar.style.display = '';
      sidebar.style.width = '';
      sidebar.style.maxWidth = '';
      sidebar.style.visibility = '';
      sidebar.style.opacity = '';
      sidebar.style.pointerEvents = '';
      sidebar.style.transform = '';
    }
  };
  mobileOpen?.addEventListener('click', () => setMobileOpen(true));
  mobileClose.forEach(button => button.addEventListener('click', () => setMobileOpen(false)));
  document.addEventListener('click', event => {
    const openButton = event.target.closest('[data-mobile-all-models-filter-open]');
    const closeButton = event.target.closest('[data-mobile-all-models-filter-close]');
    if (openButton) setMobileOpen(true);
    if (closeButton) setMobileOpen(false);
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') setMobileOpen(false);
  });
})();

/* All Models catalogue search: update results in place as the customer types. */
(() => {
  const page = document.querySelector('.all-models-page');
  const form = page?.querySelector('.all-models-search-form');
  const input = form?.querySelector('input[type="search"]');
  if (!page || !form || !input) return;

  const collectionUrl = new URL(location.href);
  collectionUrl.searchParams.delete('q');
  collectionUrl.searchParams.delete('type');
  let debounceTimer;
  let activeRequest;

  const setLoading = loading => {
    form.classList.toggle('is-loading', loading);
    form.querySelector('button')?.setAttribute('aria-busy', String(loading));
  };

  const makeEmptyState = query => {
    const column = document.createElement('div');
    column.className = 'collection-products-column';
    column.innerHTML = `<div class="empty-state"><h2>No models found</h2><p>No matches for “${query.replace(/[&<>'"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]))}”. Try another model, brand, or scale.</p></div>`;
    return column;
  };

  const replaceResults = incoming => {
    const current = page.querySelector('.collection-products-column');
    if (!current || !incoming) return;
    current.replaceWith(incoming);
    if (typeof preserveAllModelsReturnLinks === 'function') preserveAllModelsReturnLinks(incoming);
    window.dispatchEvent(new CustomEvent('kdc:products-updated', { detail: { root: incoming } }));
  };

  const search = async immediate => {
    const query = input.value.trim();
    if (activeRequest) activeRequest.abort();
    const controller = new AbortController();
    activeRequest = controller;
    if (query) setLoading(true);

    try {
      const url = query
        ? new URL(`/search?type=product&q=${encodeURIComponent(query)}`, location.origin)
        : new URL(collectionUrl.href);
      const response = await fetch(url, {
        headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' },
        signal: controller.signal
      });
      if (!response.ok) throw new Error('Unable to search models');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      let incoming;

      if (query) {
        const searchGrid = doc.querySelector('.search-page .product-grid');
        const cards = searchGrid ? [...searchGrid.children] : [];
        incoming = cards.length ? document.createElement('div') : makeEmptyState(query);
        if (cards.length) {
          incoming.className = 'collection-products-column';
          const grid = document.createElement('div');
          grid.className = 'product-grid all-models-grid';
          cards.forEach(card => grid.appendChild(card));
          incoming.appendChild(grid);
        }
        const count = page.querySelector('.new-collection-title-row p');
        if (count) count.textContent = `${cards.length} matching ${cards.length === 1 ? 'product' : 'products'}`;
        history.replaceState({}, '', `${collectionUrl.pathname}?q=${encodeURIComponent(query)}`);
      } else {
        incoming = doc.querySelector('.all-models-page .collection-products-column');
        const count = doc.querySelector('.all-models-page .new-collection-title-row p');
        const currentCount = page.querySelector('.new-collection-title-row p');
        if (count && currentCount) currentCount.textContent = count.textContent;
        history.replaceState({}, '', `${collectionUrl.pathname}${collectionUrl.search}`);
      }
      replaceResults(incoming);
    } catch (error) {
      if (error.name !== 'AbortError') form.classList.add('has-error');
    } finally {
      if (activeRequest === controller) setLoading(false);
    }
  };

  input.addEventListener('input', () => {
    window.clearTimeout(debounceTimer);
    debounceTimer = window.setTimeout(() => search(false), 280);
  });
  form.addEventListener('submit', event => {
    event.preventDefault();
    window.clearTimeout(debounceTimer);
    search(true);
  });
})();

/* KDC LimitedOrder (product metafield custom.limitedorder): max 1 unit per order. */
(() => {
  if (window.__kdcLimitedOrder) return;
  window.__kdcLimitedOrder = true;
  const LIMIT_MSG = 'Limit 1 per order. This model is already in your bag.';
  const NOTE = 'Limit 1 per order';
  const limited = new Set();
  const collect = (root = document) => {
    root.querySelectorAll('[data-order-limit-variants]').forEach(el => {
      String(el.dataset.orderLimitVariants || '').split(',').forEach(id => { id = id.trim(); if (id) limited.add(id); });
    });
    root.querySelectorAll('[data-cart-order-limits]').forEach(el => {
      try { JSON.parse(el.textContent || '[]').forEach(id => limited.add(String(id))); } catch (_) {}
    });
  };
  collect();

  const nativeFetch = window.fetch.bind(window);
  let cartCache = null;
  const loadCart = async () => {
    const res = await nativeFetch('/cart.js?_=' + Date.now(), {headers: {Accept: 'application/json'}, cache: 'no-store'});
    cartCache = await res.json();
    return cartCache;
  };
  const limitError = () => new Response(JSON.stringify({status: 422, message: LIMIT_MSG, description: LIMIT_MSG}), {status: 422, headers: {'Content-Type': 'application/json'}});
  const urlOf = input => typeof input === 'string' ? input : (input && input.url) || '';
  const inCart = (cart, id) => cart.items.some(item => String(item.variant_id) === id);

  window.fetch = async (input, init) => {
    const url = urlOf(input);
    try {
      if (limited.size && init && init.body && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
        const body = init.body;
        if (body instanceof FormData) {
          const id = String(body.get('id') || '');
          if (limited.has(id)) {
            if (inCart(await loadCart(), id)) return limitError();
            body.set('quantity', '1');
          }
        } else if (typeof body === 'string') {
          const json = JSON.parse(body);
          const list = Array.isArray(json.items) ? json.items : [json];
          const hits = list.filter(item => limited.has(String(item.id || '')));
          if (hits.length) {
            const cart = await loadCart();
            if (hits.some(item => inCart(cart, String(item.id)))) return limitError();
            hits.forEach(item => { item.quantity = 1; });
            init = {...init, body: JSON.stringify(json)};
          }
        }
      }
      if (limited.size && init && typeof init.body === 'string' && /\/cart\/change(\.js)?(\?|$)/.test(url)) {
        const json = JSON.parse(init.body);
        if (Number(json.quantity) > 1) {
          const key = String(json.id || '');
          const find = cart => (json.line ? cart.items[Number(json.line) - 1] : cart.items.find(item => item.key === key || String(item.variant_id) === key));
          let item = cartCache ? find(cartCache) : null;
          if (!item) item = find(await loadCart());
          if (item && limited.has(String(item.variant_id))) {
            json.quantity = 1;
            init = {...init, body: JSON.stringify(json)};
          }
        }
      }
    } catch (_) {}
    const res = await nativeFetch(input, init);
    if (/\/cart(\/[a-z]+)?\.js/.test(url) && !/\/cart\.js/.test(url)) cartCache = null;
    return res;
  };

  const addNote = (after, cls) => {
    if (!after || !after.parentNode) return;
    const next = after.nextElementSibling;
    if (next && next.classList.contains('kdc-order-limit-note')) return;
    const note = document.createElement('p');
    note.className = 'kdc-order-limit-note ' + (cls || '');
    note.textContent = NOTE;
    after.insertAdjacentElement('afterend', note);
  };

  const lockProductForms = () => {
    document.querySelectorAll('form').forEach(form => {
      if (!form.querySelector('[data-order-limit-variants]')) return;
      const input = form.querySelector('[data-qty-input], input[name="quantity"]:not([type="hidden"])');
      if (input) {
        input.value = '1';
        input.max = '1';
        input.readOnly = true;
        const control = input.closest('.quantity-control');
        const plus = control && control.querySelector('[data-qty-plus]');
        if (plus) plus.disabled = true;
        addNote(control || input, '');
      }
    });
  };

  const lockCartLines = async () => {
    const drawerControls = [...document.querySelectorAll('[data-cart-drawer-qty]')];
    const pageControls = [...document.querySelectorAll('[data-cart-page-qty]')];
    if (!limited.size || (!drawerControls.length && !pageControls.length)) return;
    let cart = cartCache || await loadCart();
    const over = cart.items.filter(item => limited.has(String(item.variant_id)) && item.quantity > 1);
    if (over.length) {
      for (const item of over) {
        await nativeFetch('/cart/change.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({id: item.key, quantity: 1})});
      }
      if (location.pathname.replace(/\/$/, '') === '/cart') { location.reload(); return; }
      cart = await loadCart();
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }
    const byKey = new Map(cart.items.map(item => [item.key, String(item.variant_id)]));
    drawerControls.forEach(control => {
      const variantId = byKey.get(control.dataset.lineKey || '');
      if (!variantId || !limited.has(variantId)) return;
      control.dataset.max = '1';
      const plus = control.querySelector('[data-cart-drawer-plus]');
      if (plus) plus.disabled = true;
      addNote(control.closest('.drawer-item-row') || control, 'is-drawer');
    });
    pageControls.forEach(control => {
      const variantId = String(control.dataset.variantId || byKey.get(control.dataset.lineKey || '') || '');
      if (!limited.has(variantId)) return;
      control.dataset.max = '1';
      const input = control.querySelector('input[name="updates[]"]');
      if (input) { input.max = '1'; input.readOnly = true; }
      const plus = control.querySelector('[data-cart-page-plus]');
      if (plus) plus.disabled = true;
      addNote(control.closest('.cart-line-action-row') || control, 'is-cart');
    });
  };

  let pending = false;
  const refresh = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      collect();
      lockProductForms();
      lockCartLines().catch(() => {});
    });
  };
  refresh();
  document.addEventListener('change', event => {
    if (event.target && event.target.matches && event.target.matches('[data-variant-select]')) setTimeout(refresh, 0);
  });
  new MutationObserver(refresh).observe(document.documentElement, {childList: true, subtree: true});
  const style = document.createElement('style');
  style.textContent = '.kdc-order-limit-note{margin:6px 0 0;font-size:12px;font-weight:600;color:#b45309;flex-basis:100%;width:100%}';
  document.head.appendChild(style);
})();
